import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Upload` special type represents a file to be uploaded in the same HTTP request as specified by
   *  [graphql-multipart-request-spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
   */
  Upload: { input: any; output: any; }
  /** The `Void` scalar type represents no value being returned. */
  Void: { input: any; output: any; }
}

export interface ActivateBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface ActivateModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface AddCameraToBasicConfiguratorProductInput {
  camera: CameraInput;
  configuratorId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
}

export interface AddCameraToModularConfiguratorComponentInput {
  camera: CameraInput;
  componentId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface AddEnvironmentToBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  environment: BasicConfiguratorEnvironmentInput;
}

export interface AddEnvironmentToModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  environment: ModularConfiguratorEnvironmentInput;
}

export interface AddProductToBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  product: BasicConfiguratorProductInput;
}

export interface AddProductToModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  product: ModularConfiguratorProductInput;
}

export interface AssetCreationRequest {
  __typename?: 'AssetCreationRequest';
  assetId?: Maybe<Scalars['ID']['output']>;
  assetType?: Maybe<AssetType>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  status: AssetCreationRequestStatus;
}

export enum AssetCreationRequestStatus {
  Completed = 'completed',
  Failed = 'failed',
  New = 'new',
  Validated = 'validated'
}

export enum AssetType {
  Environment = 'environment',
  Material = 'material',
  Product = 'product'
}

export interface BasicConfigurator {
  __typename?: 'BasicConfigurator';
  camera: Camera;
  client: Client;
  ctaEnabled?: Maybe<Scalars['Boolean']['output']>;
  environments: Array<BasicConfiguratorEnvironment>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productCollectionLabel: Scalars['String']['output'];
  products: Array<BasicConfiguratorProduct>;
}

export interface BasicConfiguratorEnvironment {
  __typename?: 'BasicConfiguratorEnvironment';
  environment: Environment;
  environmentId: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
}

export interface BasicConfiguratorEnvironmentInput {
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  position: Scalars['Int']['input'];
}

export interface BasicConfiguratorProduct {
  __typename?: 'BasicConfiguratorProduct';
  camera?: Maybe<Camera>;
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  product: Product;
  productId: Scalars['ID']['output'];
}

export interface BasicConfiguratorProductInput {
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  position: Scalars['Int']['input'];
}

export interface BoundariesBox {
  __typename?: 'BoundariesBox';
  end: RadiusVector;
  start: RadiusVector;
}

export interface BoundariesBoxInput {
  end: RadiusVectorInput;
  start: RadiusVectorInput;
}

export interface Camera {
  __typename?: 'Camera';
  fov: Scalars['Float']['output'];
  mode: Scalars['String']['output'];
  position: RadiusVector;
  restrictions?: Maybe<Restrictions>;
  rotation: Rotation;
}

export interface CameraInput {
  fov: Scalars['Int']['input'];
  mode: CameraMode;
  position: RadiusVectorInput;
  restrictions?: InputMaybe<RestrictionsInput>;
  rotation: RotationInput;
}

export enum CameraMode {
  Fps = 'fps',
  Orbit = 'orbit'
}

export interface CameraPreset {
  __typename?: 'CameraPreset';
  config: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  previewPath?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export interface CameraPresetListType {
  __typename?: 'CameraPresetListType';
  cameraPresets: Array<CameraPreset>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface ChangeBasicConfiguratorEnvironmentLabelInput {
  configuratorId: Scalars['ID']['input'];
  environmentId: Scalars['ID']['input'];
  label: Scalars['String']['input'];
}

export interface ChangeBasicConfiguratorEnvironmentPositionInput {
  configuratorId: Scalars['ID']['input'];
  environmentId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
}

export interface ChangeBasicConfiguratorProductCollectionLabelInput {
  configuratorId: Scalars['ID']['input'];
  productCollectionLabel: Scalars['String']['input'];
}

export interface ChangeBasicConfiguratorProductLabelInput {
  configuratorId: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
}

export interface ChangeBasicConfiguratorProductPositionInput {
  configuratorId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
}

export interface ChangeClientUnrealVersionInput {
  clientId: Scalars['ID']['input'];
  unrealVersion: UnrealVersion;
}

export interface ChangeEnvironmentPreviewFromRenderInput {
  environmentId?: InputMaybe<Scalars['ID']['input']>;
  renderId?: InputMaybe<Scalars['ID']['input']>;
}

export interface ChangeEnvironmentPreviewInput {
  environmentId?: InputMaybe<Scalars['ID']['input']>;
  preview: Scalars['Upload']['input'];
}

export interface ChangeEnvironmentSlotLabelInput {
  environmentId?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
}

export interface ChangeEnvironmentSunNorthYawInput {
  environmentId: Scalars['String']['input'];
  sunNorthYaw: Scalars['Float']['input'];
}

export interface ChangeEnvironmentTitleInput {
  environmentId: Scalars['String']['input'];
  title: Scalars['String']['input'];
}

export interface ChangeEnvironmentUdsHourInput {
  environmentId: Scalars['String']['input'];
  udsHour: Scalars['Float']['input'];
}

export interface ChangeMaterialExternalIdInput {
  externalId?: InputMaybe<Scalars['String']['input']>;
  materialId: Scalars['ID']['input'];
}

export interface ChangeMaterialPreviewInput {
  materialId?: InputMaybe<Scalars['ID']['input']>;
  preview: Scalars['Upload']['input'];
}

export interface ChangeMaterialTitleInput {
  materialId: Scalars['String']['input'];
  title: Scalars['String']['input'];
}

export interface ChangeMetaPropertyTypeInput {
  expression?: InputMaybe<Scalars['String']['input']>;
  metaPropertyId: Scalars['ID']['input'];
  type: MetaPropertyTypeInput;
}

export interface ChangeModularConfiguratorComponentPositionInput {
  componentId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
}

export interface ChangeModularConfiguratorComponentTypePositionInput {
  componentTypeId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
}

export interface ChangeModularConfiguratorEnvironmentLabelInput {
  configuratorId: Scalars['ID']['input'];
  environmentId: Scalars['ID']['input'];
  label: Scalars['String']['input'];
}

export interface ChangeModularConfiguratorEnvironmentPositionInput {
  configuratorId: Scalars['ID']['input'];
  environmentId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
}

export interface ChangeModularConfiguratorRootComponentTypeInput {
  componentTypeId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface ChangeProductExternalIdInput {
  externalId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
}

export interface ChangeProductPreviewFromRenderInput {
  productId?: InputMaybe<Scalars['ID']['input']>;
  renderId?: InputMaybe<Scalars['ID']['input']>;
}

export interface ChangeProductPreviewInput {
  preview: Scalars['Upload']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
}

export interface ChangeProductSlotLabelInput {
  label: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  slotId: Scalars['String']['input'];
}

export interface ChangeProductTitleInput {
  productId: Scalars['String']['input'];
  title: Scalars['String']['input'];
}

export interface Client {
  __typename?: 'Client';
  hasPublicAssets: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unrealVersion: Scalars['String']['output'];
}

export interface CloneBasicConfiguratorInput {
  cloneName: Scalars['String']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface CloneEnvironmentToClientInput {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  environmentId?: InputMaybe<Scalars['ID']['input']>;
}

export interface CloneMaterialToClientInput {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  materialId?: InputMaybe<Scalars['ID']['input']>;
}

export interface CloneModularConfiguratorInput {
  cloneName: Scalars['String']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface CloneProductToClientInput {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
}

export interface CreateAssetCreationRequestInput {
  chunkNumber: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  totalChunks: Scalars['Int']['input'];
}

export interface CreateAssetCreationRequestOutput {
  __typename?: 'CreateAssetCreationRequestOutput';
  completed: Scalars['Boolean']['output'];
}

export interface CreateBasicConfiguratorInput {
  environments: Array<BasicConfiguratorEnvironmentInput>;
  name: Scalars['String']['input'];
  productCollectionLabel: Scalars['String']['input'];
  products: Array<BasicConfiguratorProductInput>;
}

export interface CreateCameraPresetInput {
  config: Scalars['String']['input'];
  environmentId?: InputMaybe<Scalars['ID']['input']>;
  preview?: InputMaybe<Scalars['Upload']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
}

export interface CreateMetaPropertyInput {
  expression?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: MetaPropertyTypeInput;
}

export interface CreateModularConfiguratorComponentInput {
  camera?: InputMaybe<CameraInput>;
  componentTypeId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
  socketToConnectorsMap: Array<ModularConfiguratorComponentSocketToConnectorInput>;
}

export interface CreateModularConfiguratorComponentTypeInput {
  configuratorId: Scalars['ID']['input'];
  isRequired: Scalars['Boolean']['input'];
  isRoot: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
}

export interface CreateModularConfiguratorConnectorInput {
  componentTypeId1: Scalars['ID']['input'];
  componentTypeId2: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface CreateModularConfiguratorFromProductsInput {
  environments: Array<ModularConfiguratorEnvironmentInput>;
  name: Scalars['String']['input'];
  products: Array<ModularConfiguratorProductInput>;
  rootProductTypeId: Scalars['ID']['input'];
}

export interface CreateModularConfiguratorInput {
  environments: Array<ModularConfiguratorEnvironmentInput>;
  name: Scalars['String']['input'];
}

export interface CreatePresetInput {
  config: Scalars['String']['input'];
  environmentId: Scalars['ID']['input'];
  preview?: InputMaybe<Scalars['Upload']['input']>;
  title: Scalars['String']['input'];
}

export interface CreateProductVirtualSocketInput {
  name: Scalars['String']['input'];
  originalSockets: Array<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
}

export interface CreateRenderRequestInput {
  aiMask?: InputMaybe<Scalars['Upload']['input']>;
  background?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  environmentId?: InputMaybe<Scalars['ID']['input']>;
  fileType: RenderRequestFileTypeEnum;
  fov: Scalars['Int']['input'];
  height: Scalars['Int']['input'];
  isAsyncMode?: InputMaybe<Scalars['Boolean']['input']>;
  isPathTrace?: InputMaybe<Scalars['Boolean']['input']>;
  isTransparentBackground?: InputMaybe<Scalars['Boolean']['input']>;
  mode: RenderRequestModeEnum;
  preview?: InputMaybe<Scalars['Upload']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceRenderId?: InputMaybe<Scalars['ID']['input']>;
  width: Scalars['Int']['input'];
}

export interface CreateSpinnerRequestInput {
  imageCount: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
}

export interface Date {
  __typename?: 'Date';
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
}

export interface DeactivateBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface DeactivateModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface DeleteBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface DeleteCameraFromModularConfiguratorComponentInput {
  componentId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface DeleteCameraPresetInput {
  cameraPresetId: Scalars['String']['input'];
}

export interface DeleteComponentFromModularConfiguratorInput {
  componentId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface DeleteComponentTypeFromModularConfiguratorInput {
  componentTypeId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface DeleteConnectorFromModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  connectorId: Scalars['ID']['input'];
}

export interface DeleteEnvironmentInput {
  environmentId: Scalars['String']['input'];
}

export interface DeleteMaterialInput {
  materialId?: InputMaybe<Scalars['ID']['input']>;
}

export interface DeleteMetaPropertyInput {
  metaPropertyId: Scalars['ID']['input'];
}

export interface DeleteModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface DeletePresetInput {
  presetId: Scalars['String']['input'];
}

export interface DeleteProductInput {
  productId: Scalars['String']['input'];
}

export interface DeleteProductVirtualSocketInput {
  productId: Scalars['String']['input'];
  virtualSocketId: Scalars['String']['input'];
}

export interface DeleteRenderInput {
  renderId: Scalars['String']['input'];
}

export interface DeleteSpinnerInput {
  spinnerId: Scalars['String']['input'];
}

export interface DisableAllMaterialsForEnvironmentSlotInput {
  environmentId: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
}

export interface DisableAllMaterialsForProductSlotInput {
  productId: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
}

export interface DisableEnvironmentUdsInput {
  environmentId: Scalars['String']['input'];
}

export interface DisableMaterialForEnvironmentSlotInput {
  environmentId: Scalars['String']['input'];
  materialId: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
}

export interface DisableMaterialForProductSlotInput {
  materialId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  slotId: Scalars['String']['input'];
}

export interface EnableEnvironmentUdsInput {
  environmentId: Scalars['String']['input'];
}

export interface EnableMaterialForEnvironmentSlotInput {
  environmentId: Scalars['String']['input'];
  materialId: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
}

export interface EnableMaterialForProductSlotInput {
  materialId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
}

export interface EnableMaterialsFromAnotherEnvironmentSlotInput {
  sourceEnvironmentId: Scalars['String']['input'];
  sourceSlotId: Scalars['String']['input'];
  targetEnvironmentId: Scalars['String']['input'];
  targetSlotId: Scalars['String']['input'];
}

export interface EnableMaterialsFromAnotherProductSlotInput {
  sourceProductId: Scalars['String']['input'];
  sourceSlotId: Scalars['String']['input'];
  targetProductId: Scalars['String']['input'];
  targetSlotId: Scalars['String']['input'];
}

export interface Environment {
  __typename?: 'Environment';
  cameraPresets: CameraPresetListType;
  clientId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  legacyAssetId: Scalars['ID']['output'];
  model: Model;
  modelId: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  renders: RenderListType;
  slots: Array<Slot>;
  sunNorthYaw: Scalars['Float']['output'];
  thumbnailList: Array<Thumbnail>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  udsEnabled: Scalars['Boolean']['output'];
  udsHour: Scalars['Float']['output'];
}


export interface EnvironmentCameraPresetsArgs {
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface EnvironmentRendersArgs {
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface GetAssetCreationRequestListInput {
  requestIds: Array<Scalars['ID']['input']>;
}

export interface GetAssetCreationRequestListOutput {
  __typename?: 'GetAssetCreationRequestListOutput';
  assetCreationRequests: Array<AssetCreationRequest>;
}

export interface GetBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface GetBasicConfiguratorListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

export interface GetBasicConfiguratorListOutput {
  __typename?: 'GetBasicConfiguratorListOutput';
  basicConfigurators: Array<BasicConfigurator>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetClientInput {
  clientId: Scalars['ID']['input'];
}

export interface GetClientListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface GetClientListOutput {
  __typename?: 'GetClientListOutput';
  clients: Array<Client>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetEnvironmentInput {
  environmentId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GetEnvironmentListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyWithPresets?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

export interface GetEnvironmentListOutput {
  __typename?: 'GetEnvironmentListOutput';
  environments: Array<Environment>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetMaterialInput {
  materialId: Scalars['ID']['input'];
}

export interface GetMaterialListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

export interface GetMaterialListOutput {
  __typename?: 'GetMaterialListOutput';
  limit?: Maybe<Scalars['Int']['output']>;
  materials: Array<Material>;
  offset?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetMetaPropertyListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

export interface GetMetaPropertyListOutput {
  __typename?: 'GetMetaPropertyListOutput';
  limit?: Maybe<Scalars['Int']['output']>;
  metaProperties: Array<MetaProperty>;
  offset?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface GetModularConfiguratorListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

export interface GetModularConfiguratorListOutput {
  __typename?: 'GetModularConfiguratorListOutput';
  limit: Scalars['Int']['output'];
  modularConfigurators: Array<ModularConfigurator>;
  offset: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetPresetListInput {
  countTotal: Scalars['Boolean']['input'];
  environmentId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface GetPresetListOutput {
  __typename?: 'GetPresetListOutput';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  presets: Array<Preset>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetProductInput {
  productId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GetProductListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyWithSockets?: InputMaybe<Scalars['Boolean']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

export interface GetProductListOutput {
  __typename?: 'GetProductListOutput';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  products: Array<Product>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetRenderInput {
  renderId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GetRenderListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface GetRenderRequestInput {
  renderRequestId: Scalars['ID']['input'];
}

export interface GetSpinnerInput {
  spinnerId?: InputMaybe<Scalars['ID']['input']>;
}

export interface IdOutput {
  __typename?: 'IdOutput';
  id?: Maybe<Scalars['ID']['output']>;
}

export interface ImportProductsMetaDataInput {
  chunkNumber: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
  totalChunks: Scalars['Int']['input'];
  uploadId: Scalars['ID']['input'];
}

export interface ImportProductsMetaDataOutput {
  __typename?: 'ImportProductsMetaDataOutput';
  completed: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
}

export interface LinkOriginalSocketInput {
  originalSocket: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  virtualSocketId: Scalars['String']['input'];
}

export interface MapModularConfiguratorComponentSocketToConnectorInput {
  componentId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
  connectorId: Scalars['ID']['input'];
  virtualSocketId: Scalars['ID']['input'];
}

export interface Material {
  __typename?: 'Material';
  bigThumbnailUrl?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  model: Model;
  modelId: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  smallThumbnailUrl?: Maybe<Scalars['String']['output']>;
  thumbnailList: Array<Thumbnail>;
  title: Scalars['String']['output'];
}

export interface MetaProperty {
  __typename?: 'MetaProperty';
  expression?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export enum MetaPropertyTypeInput {
  Bool = 'bool',
  Float = 'float',
  Int = 'int',
  Regexp = 'regexp',
  String = 'string'
}

export interface Model {
  __typename?: 'Model';
  assetPath: Scalars['String']['output'];
  id: Scalars['String']['output'];
  pakFilePath: Scalars['String']['output'];
  unrealVersion: Scalars['String']['output'];
}

export interface ModularConfigurator {
  __typename?: 'ModularConfigurator';
  camera: Camera;
  client: Client;
  componentTypes: Array<ModularConfiguratorComponentType>;
  components: Array<ModularConfiguratorComponent>;
  connectors: Array<ModularConfiguratorConnector>;
  ctaEnabled?: Maybe<Scalars['Boolean']['output']>;
  environments: Array<ModularConfiguratorEnvironment>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
}

export interface ModularConfiguratorComponent {
  __typename?: 'ModularConfiguratorComponent';
  camera?: Maybe<Camera>;
  componentType?: Maybe<ModularConfiguratorComponentType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  product: Product;
  virtualSocketToConnectorsMap: Array<ModularConfiguratorVirtualSocketToConnector>;
}

export interface ModularConfiguratorComponentSocketToConnectorInput {
  connectorId: Scalars['String']['input'];
  socketId: Scalars['String']['input'];
}

export interface ModularConfiguratorComponentType {
  __typename?: 'ModularConfiguratorComponentType';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  isRoot: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
}

export interface ModularConfiguratorConnector {
  __typename?: 'ModularConfiguratorConnector';
  componentTypeId1: Scalars['ID']['output'];
  componentTypeId2: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
}

export interface ModularConfiguratorEnvironment {
  __typename?: 'ModularConfiguratorEnvironment';
  environment: Environment;
  environmentId: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
}

export interface ModularConfiguratorEnvironmentInput {
  id: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
}

export interface ModularConfiguratorProductInput {
  id: Scalars['String']['input'];
  position: Scalars['Int']['input'];
}

export interface ModularConfiguratorVirtualSocketToConnector {
  __typename?: 'ModularConfiguratorVirtualSocketToConnector';
  connectorId: Scalars['ID']['output'];
  virtualSocketId: Scalars['ID']['output'];
}

export interface MoveEnvironmentMaterialInput {
  environmentId: Scalars['String']['input'];
  fromPosition: Scalars['Int']['input'];
  slotId: Scalars['String']['input'];
  toPosition: Scalars['Int']['input'];
}

export interface MoveProductMaterialInput {
  fromPosition: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
  toPosition: Scalars['Int']['input'];
}

export interface Mutation {
  __typename?: 'Mutation';
  activateBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  activateModularConfigurator?: Maybe<Scalars['Void']['output']>;
  addCameraToBasicConfiguratorProduct?: Maybe<Scalars['Void']['output']>;
  addCameraToModularConfiguratorComponent?: Maybe<Scalars['Void']['output']>;
  addEnvironmentToBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  addEnvironmentToModularConfigurator?: Maybe<Scalars['Void']['output']>;
  addProductToBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  addProductToModularConfigurator: IdOutput;
  changeBasicConfiguratorEnvironmentLabel?: Maybe<Scalars['Void']['output']>;
  changeBasicConfiguratorEnvironmentPosition?: Maybe<Scalars['Void']['output']>;
  changeBasicConfiguratorProductCollectionLabel?: Maybe<Scalars['Void']['output']>;
  changeBasicConfiguratorProductLabel?: Maybe<Scalars['Void']['output']>;
  changeBasicConfiguratorProductPosition?: Maybe<Scalars['Void']['output']>;
  changeClientUnrealVersion?: Maybe<Scalars['Void']['output']>;
  changeEnvironmentPreview?: Maybe<Scalars['Void']['output']>;
  changeEnvironmentPreviewFromRender?: Maybe<Scalars['Void']['output']>;
  changeEnvironmentSlotLabel?: Maybe<Scalars['Void']['output']>;
  changeEnvironmentSunNorthYaw?: Maybe<Scalars['Void']['output']>;
  changeEnvironmentTitle?: Maybe<Scalars['Void']['output']>;
  changeEnvironmentUdsHour?: Maybe<Scalars['Void']['output']>;
  changeMaterialExternalId?: Maybe<Scalars['Void']['output']>;
  changeMaterialPreview?: Maybe<Scalars['Void']['output']>;
  changeMaterialTitle?: Maybe<Scalars['Void']['output']>;
  changeMetaPropertyType?: Maybe<Scalars['Void']['output']>;
  changeModularConfiguratorComponentPosition?: Maybe<Scalars['Void']['output']>;
  changeModularConfiguratorComponentTypePosition?: Maybe<Scalars['Void']['output']>;
  changeModularConfiguratorEnvironmentLabel?: Maybe<Scalars['Void']['output']>;
  changeModularConfiguratorEnvironmentPosition?: Maybe<Scalars['Void']['output']>;
  changeModularConfiguratorRootComponentType?: Maybe<Scalars['Void']['output']>;
  changeProductExternalId?: Maybe<Scalars['Void']['output']>;
  changeProductPreview?: Maybe<Scalars['Void']['output']>;
  changeProductPreviewFromRender?: Maybe<Scalars['Void']['output']>;
  changeProductSlotLabel?: Maybe<Scalars['Void']['output']>;
  changeProductTitle?: Maybe<Scalars['Void']['output']>;
  cloneBasicConfigurator: IdOutput;
  cloneEnvironmentToClient: IdOutput;
  cloneMaterialToClient: IdOutput;
  cloneModularConfigurator: IdOutput;
  cloneProductToClient: IdOutput;
  createAssetCreationRequest: CreateAssetCreationRequestOutput;
  createBasicConfigurator: IdOutput;
  createCameraPreset: IdOutput;
  createMetaProperty: IdOutput;
  createModularConfigurator: IdOutput;
  createModularConfiguratorComponent: IdOutput;
  createModularConfiguratorComponentType: IdOutput;
  createModularConfiguratorConnector: IdOutput;
  createModularConfiguratorFromProducts: IdOutput;
  createPreset: Preset;
  createProductVirtualSocket?: Maybe<Scalars['Void']['output']>;
  createRenderRequest: IdOutput;
  createSpinnerRequest: SpinnerRequest;
  deactivateBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  deactivateModularConfigurator?: Maybe<Scalars['Void']['output']>;
  deleteBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  deleteCameraFromModularConfiguratorComponent?: Maybe<Scalars['Void']['output']>;
  deleteCameraPreset?: Maybe<Scalars['Void']['output']>;
  deleteComponentFromModularConfigurator?: Maybe<Scalars['Void']['output']>;
  deleteComponentTypeFromModularConfigurator?: Maybe<Scalars['Void']['output']>;
  deleteConnectorFromModularConfigurator?: Maybe<Scalars['Void']['output']>;
  deleteEnvironment?: Maybe<Scalars['Void']['output']>;
  deleteMaterial?: Maybe<Scalars['Void']['output']>;
  deleteMetaProperty?: Maybe<Scalars['Void']['output']>;
  deleteModularConfigurator?: Maybe<Scalars['Void']['output']>;
  deletePreset?: Maybe<Scalars['Void']['output']>;
  deleteProduct?: Maybe<Scalars['Void']['output']>;
  deleteProductVirtualSocket?: Maybe<Scalars['Void']['output']>;
  deleteRender?: Maybe<Scalars['Void']['output']>;
  deleteSpinner?: Maybe<Scalars['Void']['output']>;
  disableAllMaterialsForEnvironmentSlot?: Maybe<Scalars['Void']['output']>;
  disableAllMaterialsForProductSlot?: Maybe<Scalars['Void']['output']>;
  disableEnvironmentUds?: Maybe<Scalars['Void']['output']>;
  disableMaterialForEnvironmentSlot?: Maybe<Scalars['Void']['output']>;
  disableMaterialForProductSlot?: Maybe<Scalars['Void']['output']>;
  enableEnvironmentUds?: Maybe<Scalars['Void']['output']>;
  enableMaterialForEnvironmentSlot?: Maybe<Scalars['Void']['output']>;
  enableMaterialForProductSlot?: Maybe<Scalars['Void']['output']>;
  enableMaterialsFromAnotherEnvironmentSlot?: Maybe<Scalars['Void']['output']>;
  enableMaterialsFromAnotherProductSlot?: Maybe<Scalars['Void']['output']>;
  importProductsMetaData: ImportProductsMetaDataOutput;
  linkOriginalSocket?: Maybe<Scalars['Void']['output']>;
  login: SymfonyUserInterface;
  logout: Scalars['Boolean']['output'];
  mapModularConfiguratorComponentSocketToConnector?: Maybe<Scalars['Void']['output']>;
  moveEnvironmentMaterial?: Maybe<Scalars['Void']['output']>;
  moveProductMaterial?: Maybe<Scalars['Void']['output']>;
  removeCameraFromBasicConfiguratorProduct?: Maybe<Scalars['Void']['output']>;
  removeEnvironmentFromBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  removeEnvironmentFromModularConfigurator?: Maybe<Scalars['Void']['output']>;
  removeProductFromBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  removeProductMetaProperty?: Maybe<Scalars['Void']['output']>;
  renameBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  renameMetaProperty?: Maybe<Scalars['Void']['output']>;
  renameModularConfigurator?: Maybe<Scalars['Void']['output']>;
  renameModularConfiguratorComponent?: Maybe<Scalars['Void']['output']>;
  renameModularConfiguratorComponentType?: Maybe<Scalars['Void']['output']>;
  renameProductVirtualSocket?: Maybe<Scalars['Void']['output']>;
  setCameraToBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  setCameraToModularConfigurator?: Maybe<Scalars['Void']['output']>;
  setProductLowBandwidthTimecodes?: Maybe<Scalars['Void']['output']>;
  setProductMetaProperty?: Maybe<Scalars['Void']['output']>;
  unlinkOriginalSocket?: Maybe<Scalars['Void']['output']>;
  unmapModularConfiguratorComponentSocketFromConnector?: Maybe<Scalars['Void']['output']>;
  updateEnvironmentModel: UpdateEnvironmentModelOutput;
  updateMaterialModel: UpdateMaterialModelOutput;
  updateProductModel: UpdateProductModelOutput;
}


export interface MutationActivateBasicConfiguratorArgs {
  input: ActivateBasicConfiguratorInput;
}


export interface MutationActivateModularConfiguratorArgs {
  input: ActivateModularConfiguratorInput;
}


export interface MutationAddCameraToBasicConfiguratorProductArgs {
  input: AddCameraToBasicConfiguratorProductInput;
}


export interface MutationAddCameraToModularConfiguratorComponentArgs {
  input: AddCameraToModularConfiguratorComponentInput;
}


export interface MutationAddEnvironmentToBasicConfiguratorArgs {
  input: AddEnvironmentToBasicConfiguratorInput;
}


export interface MutationAddEnvironmentToModularConfiguratorArgs {
  input: AddEnvironmentToModularConfiguratorInput;
}


export interface MutationAddProductToBasicConfiguratorArgs {
  input: AddProductToBasicConfiguratorInput;
}


export interface MutationAddProductToModularConfiguratorArgs {
  input: AddProductToModularConfiguratorInput;
}


export interface MutationChangeBasicConfiguratorEnvironmentLabelArgs {
  input: ChangeBasicConfiguratorEnvironmentLabelInput;
}


export interface MutationChangeBasicConfiguratorEnvironmentPositionArgs {
  input: ChangeBasicConfiguratorEnvironmentPositionInput;
}


export interface MutationChangeBasicConfiguratorProductCollectionLabelArgs {
  input: ChangeBasicConfiguratorProductCollectionLabelInput;
}


export interface MutationChangeBasicConfiguratorProductLabelArgs {
  input: ChangeBasicConfiguratorProductLabelInput;
}


export interface MutationChangeBasicConfiguratorProductPositionArgs {
  input: ChangeBasicConfiguratorProductPositionInput;
}


export interface MutationChangeClientUnrealVersionArgs {
  input: ChangeClientUnrealVersionInput;
}


export interface MutationChangeEnvironmentPreviewArgs {
  input: ChangeEnvironmentPreviewInput;
}


export interface MutationChangeEnvironmentPreviewFromRenderArgs {
  input: ChangeEnvironmentPreviewFromRenderInput;
}


export interface MutationChangeEnvironmentSlotLabelArgs {
  input: ChangeEnvironmentSlotLabelInput;
}


export interface MutationChangeEnvironmentSunNorthYawArgs {
  input: ChangeEnvironmentSunNorthYawInput;
}


export interface MutationChangeEnvironmentTitleArgs {
  input: ChangeEnvironmentTitleInput;
}


export interface MutationChangeEnvironmentUdsHourArgs {
  input: ChangeEnvironmentUdsHourInput;
}


export interface MutationChangeMaterialExternalIdArgs {
  input: ChangeMaterialExternalIdInput;
}


export interface MutationChangeMaterialPreviewArgs {
  input: ChangeMaterialPreviewInput;
}


export interface MutationChangeMaterialTitleArgs {
  input: ChangeMaterialTitleInput;
}


export interface MutationChangeMetaPropertyTypeArgs {
  input: ChangeMetaPropertyTypeInput;
}


export interface MutationChangeModularConfiguratorComponentPositionArgs {
  input: ChangeModularConfiguratorComponentPositionInput;
}


export interface MutationChangeModularConfiguratorComponentTypePositionArgs {
  input: ChangeModularConfiguratorComponentTypePositionInput;
}


export interface MutationChangeModularConfiguratorEnvironmentLabelArgs {
  input: ChangeModularConfiguratorEnvironmentLabelInput;
}


export interface MutationChangeModularConfiguratorEnvironmentPositionArgs {
  input: ChangeModularConfiguratorEnvironmentPositionInput;
}


export interface MutationChangeModularConfiguratorRootComponentTypeArgs {
  input: ChangeModularConfiguratorRootComponentTypeInput;
}


export interface MutationChangeProductExternalIdArgs {
  input: ChangeProductExternalIdInput;
}


export interface MutationChangeProductPreviewArgs {
  input: ChangeProductPreviewInput;
}


export interface MutationChangeProductPreviewFromRenderArgs {
  input: ChangeProductPreviewFromRenderInput;
}


export interface MutationChangeProductSlotLabelArgs {
  input: ChangeProductSlotLabelInput;
}


export interface MutationChangeProductTitleArgs {
  input: ChangeProductTitleInput;
}


export interface MutationCloneBasicConfiguratorArgs {
  input: CloneBasicConfiguratorInput;
}


export interface MutationCloneEnvironmentToClientArgs {
  input: CloneEnvironmentToClientInput;
}


export interface MutationCloneMaterialToClientArgs {
  input: CloneMaterialToClientInput;
}


export interface MutationCloneModularConfiguratorArgs {
  input: CloneModularConfiguratorInput;
}


export interface MutationCloneProductToClientArgs {
  input: CloneProductToClientInput;
}


export interface MutationCreateAssetCreationRequestArgs {
  input: CreateAssetCreationRequestInput;
}


export interface MutationCreateBasicConfiguratorArgs {
  input: CreateBasicConfiguratorInput;
}


export interface MutationCreateCameraPresetArgs {
  input: CreateCameraPresetInput;
}


export interface MutationCreateMetaPropertyArgs {
  input: CreateMetaPropertyInput;
}


export interface MutationCreateModularConfiguratorArgs {
  input: CreateModularConfiguratorInput;
}


export interface MutationCreateModularConfiguratorComponentArgs {
  input: CreateModularConfiguratorComponentInput;
}


export interface MutationCreateModularConfiguratorComponentTypeArgs {
  input: CreateModularConfiguratorComponentTypeInput;
}


export interface MutationCreateModularConfiguratorConnectorArgs {
  input: CreateModularConfiguratorConnectorInput;
}


export interface MutationCreateModularConfiguratorFromProductsArgs {
  input: CreateModularConfiguratorFromProductsInput;
}


export interface MutationCreatePresetArgs {
  input: CreatePresetInput;
}


export interface MutationCreateProductVirtualSocketArgs {
  input: CreateProductVirtualSocketInput;
}


export interface MutationCreateRenderRequestArgs {
  input: CreateRenderRequestInput;
}


export interface MutationCreateSpinnerRequestArgs {
  input: CreateSpinnerRequestInput;
}


export interface MutationDeactivateBasicConfiguratorArgs {
  input: DeactivateBasicConfiguratorInput;
}


export interface MutationDeactivateModularConfiguratorArgs {
  input: DeactivateModularConfiguratorInput;
}


export interface MutationDeleteBasicConfiguratorArgs {
  input: DeleteBasicConfiguratorInput;
}


export interface MutationDeleteCameraFromModularConfiguratorComponentArgs {
  input: DeleteCameraFromModularConfiguratorComponentInput;
}


export interface MutationDeleteCameraPresetArgs {
  input: DeleteCameraPresetInput;
}


export interface MutationDeleteComponentFromModularConfiguratorArgs {
  input: DeleteComponentFromModularConfiguratorInput;
}


export interface MutationDeleteComponentTypeFromModularConfiguratorArgs {
  input: DeleteComponentTypeFromModularConfiguratorInput;
}


export interface MutationDeleteConnectorFromModularConfiguratorArgs {
  input: DeleteConnectorFromModularConfiguratorInput;
}


export interface MutationDeleteEnvironmentArgs {
  input: DeleteEnvironmentInput;
}


export interface MutationDeleteMaterialArgs {
  input: DeleteMaterialInput;
}


export interface MutationDeleteMetaPropertyArgs {
  input: DeleteMetaPropertyInput;
}


export interface MutationDeleteModularConfiguratorArgs {
  input: DeleteModularConfiguratorInput;
}


export interface MutationDeletePresetArgs {
  input: DeletePresetInput;
}


export interface MutationDeleteProductArgs {
  input: DeleteProductInput;
}


export interface MutationDeleteProductVirtualSocketArgs {
  input: DeleteProductVirtualSocketInput;
}


export interface MutationDeleteRenderArgs {
  input: DeleteRenderInput;
}


export interface MutationDeleteSpinnerArgs {
  input: DeleteSpinnerInput;
}


export interface MutationDisableAllMaterialsForEnvironmentSlotArgs {
  input: DisableAllMaterialsForEnvironmentSlotInput;
}


export interface MutationDisableAllMaterialsForProductSlotArgs {
  input: DisableAllMaterialsForProductSlotInput;
}


export interface MutationDisableEnvironmentUdsArgs {
  input: DisableEnvironmentUdsInput;
}


export interface MutationDisableMaterialForEnvironmentSlotArgs {
  input: DisableMaterialForEnvironmentSlotInput;
}


export interface MutationDisableMaterialForProductSlotArgs {
  input: DisableMaterialForProductSlotInput;
}


export interface MutationEnableEnvironmentUdsArgs {
  input: EnableEnvironmentUdsInput;
}


export interface MutationEnableMaterialForEnvironmentSlotArgs {
  input: EnableMaterialForEnvironmentSlotInput;
}


export interface MutationEnableMaterialForProductSlotArgs {
  input: EnableMaterialForProductSlotInput;
}


export interface MutationEnableMaterialsFromAnotherEnvironmentSlotArgs {
  input: EnableMaterialsFromAnotherEnvironmentSlotInput;
}


export interface MutationEnableMaterialsFromAnotherProductSlotArgs {
  input: EnableMaterialsFromAnotherProductSlotInput;
}


export interface MutationImportProductsMetaDataArgs {
  input: ImportProductsMetaDataInput;
}


export interface MutationLinkOriginalSocketArgs {
  input: LinkOriginalSocketInput;
}


export interface MutationLoginArgs {
  password: Scalars['String']['input'];
  userName: Scalars['String']['input'];
}


export interface MutationMapModularConfiguratorComponentSocketToConnectorArgs {
  input: MapModularConfiguratorComponentSocketToConnectorInput;
}


export interface MutationMoveEnvironmentMaterialArgs {
  input: MoveEnvironmentMaterialInput;
}


export interface MutationMoveProductMaterialArgs {
  input: MoveProductMaterialInput;
}


export interface MutationRemoveCameraFromBasicConfiguratorProductArgs {
  input: RemoveCameraFromBasicConfiguratorProductInput;
}


export interface MutationRemoveEnvironmentFromBasicConfiguratorArgs {
  input: RemoveEnvironmentFromBasicConfiguratorInput;
}


export interface MutationRemoveEnvironmentFromModularConfiguratorArgs {
  input: RemoveEnvironmentFromModularConfiguratorInput;
}


export interface MutationRemoveProductFromBasicConfiguratorArgs {
  input: RemoveProductFromBasicConfiguratorInput;
}


export interface MutationRemoveProductMetaPropertyArgs {
  input: RemoveProductMetaPropertyInput;
}


export interface MutationRenameBasicConfiguratorArgs {
  input: RenameBasicConfiguratorInput;
}


export interface MutationRenameMetaPropertyArgs {
  input: RenameMetaPropertyInput;
}


export interface MutationRenameModularConfiguratorArgs {
  input: RenameModularConfiguratorInput;
}


export interface MutationRenameModularConfiguratorComponentArgs {
  input: RenameModularConfiguratorComponentInput;
}


export interface MutationRenameModularConfiguratorComponentTypeArgs {
  input: RenameModularConfiguratorComponentTypeInput;
}


export interface MutationRenameProductVirtualSocketArgs {
  input: RenameProductVirtualSocketInput;
}


export interface MutationSetCameraToBasicConfiguratorArgs {
  input: SetCameraToBasicConfiguratorInput;
}


export interface MutationSetCameraToModularConfiguratorArgs {
  input: SetCameraToModularConfiguratorInput;
}


export interface MutationSetProductLowBandwidthTimecodesArgs {
  input: SetProductLowBandwidthTimecodesInput;
}


export interface MutationSetProductMetaPropertyArgs {
  input: SetProductMetaPropertyInput;
}


export interface MutationUnlinkOriginalSocketArgs {
  input: UnlinkOriginalSocketInput;
}


export interface MutationUnmapModularConfiguratorComponentSocketFromConnectorArgs {
  input: UnmapModularConfiguratorComponentSocketFromConnectorInput;
}


export interface MutationUpdateEnvironmentModelArgs {
  input: UpdateEnvironmentModelInput;
}


export interface MutationUpdateMaterialModelArgs {
  input: UpdateMaterialModelInput;
}


export interface MutationUpdateProductModelArgs {
  input: UpdateProductModelInput;
}

export interface Preset {
  __typename?: 'Preset';
  config: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  environment: Environment;
  id: Scalars['ID']['output'];
  previewPath?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export interface Product {
  __typename?: 'Product';
  cameraPresets: CameraPresetListType;
  clientId: Scalars['ID']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  hasShowcase: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  legacyAssetId: Scalars['ID']['output'];
  metaProperties: Array<ProductMetaProperty>;
  model: Model;
  modelId: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductType>;
  renders: RenderListType;
  showcase?: Maybe<Showcase>;
  slots: Array<Slot>;
  spinners: SpinnerListType;
  thumbnailList: Array<Thumbnail>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  virtualSockets: Array<VirtualSocket>;
}


export interface ProductCameraPresetsArgs {
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface ProductRendersArgs {
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface ProductSpinnersArgs {
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface ProductMetaProperty {
  __typename?: 'ProductMetaProperty';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface ProductType {
  __typename?: 'ProductType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface Query {
  __typename?: 'Query';
  assetCreationRequestList: GetAssetCreationRequestListOutput;
  basicConfigurator: BasicConfigurator;
  basicConfiguratorList: GetBasicConfiguratorListOutput;
  client: Client;
  clientList: GetClientListOutput;
  environment: Environment;
  environmentList: GetEnvironmentListOutput;
  material: Material;
  materialList: GetMaterialListOutput;
  me?: Maybe<SymfonyUserInterface>;
  metaPropertyList: GetMetaPropertyListOutput;
  modularConfigurator: ModularConfigurator;
  modularConfiguratorList: GetModularConfiguratorListOutput;
  presetList: GetPresetListOutput;
  product: Product;
  productList: GetProductListOutput;
  render: Render;
  renderList: RenderListType;
  renderRequest: RenderRequest;
  spinner: Spinner;
}


export interface QueryAssetCreationRequestListArgs {
  input: GetAssetCreationRequestListInput;
}


export interface QueryBasicConfiguratorArgs {
  input: GetBasicConfiguratorInput;
}


export interface QueryBasicConfiguratorListArgs {
  input: GetBasicConfiguratorListInput;
}


export interface QueryClientArgs {
  input: GetClientInput;
}


export interface QueryClientListArgs {
  input: GetClientListInput;
}


export interface QueryEnvironmentArgs {
  input: GetEnvironmentInput;
}


export interface QueryEnvironmentListArgs {
  input: GetEnvironmentListInput;
}


export interface QueryMaterialArgs {
  input: GetMaterialInput;
}


export interface QueryMaterialListArgs {
  input: GetMaterialListInput;
}


export interface QueryMetaPropertyListArgs {
  input: GetMetaPropertyListInput;
}


export interface QueryModularConfiguratorArgs {
  input: GetModularConfiguratorInput;
}


export interface QueryModularConfiguratorListArgs {
  input: GetModularConfiguratorListInput;
}


export interface QueryPresetListArgs {
  input: GetPresetListInput;
}


export interface QueryProductArgs {
  input: GetProductInput;
}


export interface QueryProductListArgs {
  input: GetProductListInput;
}


export interface QueryRenderArgs {
  input: GetRenderInput;
}


export interface QueryRenderListArgs {
  input: GetRenderListInput;
}


export interface QueryRenderRequestArgs {
  input: GetRenderRequestInput;
}


export interface QuerySpinnerArgs {
  input: GetSpinnerInput;
}

export interface RadiusVector {
  __typename?: 'RadiusVector';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  z: Scalars['Float']['output'];
}

export interface RadiusVectorInput {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  z: Scalars['Float']['input'];
}

export interface RemoveCameraFromBasicConfiguratorProductInput {
  configuratorId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
}

export interface RemoveEnvironmentFromBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  environmentId: Scalars['ID']['input'];
}

export interface RemoveEnvironmentFromModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  environmentId: Scalars['ID']['input'];
}

export interface RemoveProductFromBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
}

export interface RemoveProductMetaPropertyInput {
  metaPropertyId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
}

export interface RenameBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface RenameMetaPropertyInput {
  metaPropertyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface RenameModularConfiguratorComponentInput {
  componentId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface RenameModularConfiguratorComponentTypeInput {
  componentTypeId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface RenameModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface RenameProductVirtualSocketInput {
  name: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  virtualSocketId?: InputMaybe<Scalars['ID']['input']>;
}

export interface Render {
  __typename?: 'Render';
  executionTime: Scalars['Int']['output'];
  filePath: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  fullSizePreviewPath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  renderRequest: RenderRequest;
}

export interface RenderListType {
  __typename?: 'RenderListType';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  renders: Array<Render>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface RenderRequest {
  __typename?: 'RenderRequest';
  author?: Maybe<User>;
  background?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Environment>;
  fileType: RenderRequestFileTypeEnum;
  fov: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isAsyncMode: Scalars['Boolean']['output'];
  mode: RenderRequestModeEnum;
  previewPath?: Maybe<Scalars['String']['output']>;
  products: Array<Product>;
  renderId?: Maybe<Scalars['ID']['output']>;
  renderResultUrl: Scalars['String']['output'];
  serialNumber: Scalars['Int']['output'];
  status: RequestStatusEnum;
  width: Scalars['Int']['output'];
}

export enum RenderRequestFileTypeEnum {
  Jpg = 'jpg',
  Png = 'png',
  Tiff = 'tiff'
}

export enum RenderRequestModeEnum {
  Ai = 'ai',
  Unreal = 'unreal'
}

export enum RequestStatusEnum {
  Completed = 'completed',
  Failed = 'failed',
  InProgress = 'in_progress',
  New = 'new'
}

export interface Restrictions {
  __typename?: 'Restrictions';
  maxPitch?: Maybe<Scalars['Float']['output']>;
  maxYaw?: Maybe<Scalars['Float']['output']>;
  maxZoom?: Maybe<Scalars['Float']['output']>;
  minPitch?: Maybe<Scalars['Float']['output']>;
  minYaw?: Maybe<Scalars['Float']['output']>;
  minZoom?: Maybe<Scalars['Float']['output']>;
  panBoundariesBox?: Maybe<BoundariesBox>;
  panBoundariesRadius?: Maybe<Scalars['Float']['output']>;
}

export interface RestrictionsInput {
  maxPitch?: InputMaybe<Scalars['Float']['input']>;
  maxYaw?: InputMaybe<Scalars['Float']['input']>;
  maxZoom?: InputMaybe<Scalars['Float']['input']>;
  minPitch?: InputMaybe<Scalars['Float']['input']>;
  minYaw?: InputMaybe<Scalars['Float']['input']>;
  minZoom?: InputMaybe<Scalars['Float']['input']>;
  panBoundariesBox?: InputMaybe<BoundariesBoxInput>;
  panBoundariesRadius?: InputMaybe<Scalars['Float']['input']>;
}

export interface Rotation {
  __typename?: 'Rotation';
  pitch: Scalars['Float']['output'];
  roll: Scalars['Float']['output'];
  yaw: Scalars['Float']['output'];
}

export interface RotationInput {
  pitch: Scalars['Float']['input'];
  roll: Scalars['Float']['input'];
  yaw: Scalars['Float']['input'];
}

export interface SetCameraToBasicConfiguratorInput {
  camera: CameraInput;
  configuratorId: Scalars['ID']['input'];
}

export interface SetCameraToModularConfiguratorInput {
  camera: CameraInput;
  configuratorId: Scalars['ID']['input'];
}

export interface SetProductLowBandwidthTimecodesInput {
  productId: Scalars['ID']['input'];
  timecodes: Array<Scalars['Float']['input']>;
}

export interface SetProductMetaPropertyInput {
  metaPropertyId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}

export interface Showcase {
  __typename?: 'Showcase';
  duration?: Maybe<Scalars['Float']['output']>;
  lowBandwidth: Array<Timecode>;
}

export interface Slot {
  __typename?: 'Slot';
  enabledMaterials: Array<Material>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
}

export interface Spinner {
  __typename?: 'Spinner';
  defaultX: Scalars['Int']['output'];
  endX: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  maskX: Scalars['String']['output'];
  path: Scalars['String']['output'];
  startX: Scalars['Int']['output'];
  status: RequestStatusEnum;
  template: Scalars['String']['output'];
}

export interface SpinnerListType {
  __typename?: 'SpinnerListType';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  spinners: Array<Spinner>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface SpinnerRequest {
  __typename?: 'SpinnerRequest';
  id: Scalars['ID']['output'];
  spinnerId: Scalars['ID']['output'];
  status: RequestStatusEnum;
  uploadUrl: Scalars['String']['output'];
}

export interface SymfonyUserImpl extends SymfonyUserInterface {
  __typename?: 'SymfonyUserImpl';
  roles: Array<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
}

export interface SymfonyUserInterface {
  roles: Array<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
}

export interface Thumbnail {
  __typename?: 'Thumbnail';
  height: Scalars['Int']['output'];
  urlPath: Scalars['String']['output'];
  width: Scalars['Int']['output'];
}

export interface Time {
  __typename?: 'Time';
  hour: Scalars['Int']['output'];
  minute: Scalars['Int']['output'];
  second: Scalars['Int']['output'];
}

export interface Timecode {
  __typename?: 'Timecode';
  duration: Scalars['Float']['output'];
  time: Scalars['Float']['output'];
}

export interface UnlinkOriginalSocketInput {
  originalSocket: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  virtualSocketId: Scalars['String']['input'];
}

export interface UnmapModularConfiguratorComponentSocketFromConnectorInput {
  componentId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
  connectorId: Scalars['ID']['input'];
  socketId: Scalars['ID']['input'];
}

export enum UnrealVersion {
  V_51 = 'v_51',
  V_53 = 'v_53'
}

export interface UpdateEnvironmentModelInput {
  chunkNumber: Scalars['Int']['input'];
  environmentId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
  totalChunks: Scalars['Int']['input'];
  uploadId: Scalars['ID']['input'];
}

export interface UpdateEnvironmentModelOutput {
  __typename?: 'UpdateEnvironmentModelOutput';
  completed: Scalars['Boolean']['output'];
}

export interface UpdateMaterialModelInput {
  chunkNumber: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
  materialId: Scalars['ID']['input'];
  totalChunks: Scalars['Int']['input'];
  uploadId: Scalars['ID']['input'];
}

export interface UpdateMaterialModelOutput {
  __typename?: 'UpdateMaterialModelOutput';
  completed: Scalars['Boolean']['output'];
}

export interface UpdateProductModelInput {
  chunkNumber: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
  productId: Scalars['ID']['input'];
  totalChunks: Scalars['Int']['input'];
  uploadId: Scalars['ID']['input'];
}

export interface UpdateProductModelOutput {
  __typename?: 'UpdateProductModelOutput';
  completed: Scalars['Boolean']['output'];
}

export interface User {
  __typename?: 'User';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
}

export interface VirtualSocket {
  __typename?: 'VirtualSocket';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  originalSockets: Array<Scalars['String']['output']>;
}

export type ThumbnailFragment = { __typename?: 'Thumbnail', width: number, height: number, urlPath: string };

export type ModelFragment = { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string };

export type SpinnerFragment = { __typename?: 'Spinner', id: string, path: string, template: string, startX: number, endX: number, defaultX: number, maskX: string, status: RequestStatusEnum };

export type RadiusVectorFragment = { __typename?: 'RadiusVector', x: number, y: number, z: number };

export type RotationFragment = { __typename?: 'Rotation', pitch: number, yaw: number, roll: number };

export type RestrictionsFragment = { __typename?: 'Restrictions', maxZoom?: number | null, minZoom?: number | null, minPitch?: number | null, maxPitch?: number | null, maxYaw?: number | null, minYaw?: number | null, panBoundariesRadius?: number | null, panBoundariesBox?: { __typename?: 'BoundariesBox', start: { __typename?: 'RadiusVector', x: number, y: number, z: number }, end: { __typename?: 'RadiusVector', x: number, y: number, z: number } } | null };

export type SlotDataFragment = { __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> };

export type CameraFragment = { __typename?: 'Camera', mode: string, fov: number, position: { __typename?: 'RadiusVector', x: number, y: number, z: number }, rotation: { __typename?: 'Rotation', pitch: number, yaw: number, roll: number }, restrictions?: { __typename?: 'Restrictions', maxZoom?: number | null, minZoom?: number | null, minPitch?: number | null, maxPitch?: number | null, maxYaw?: number | null, minYaw?: number | null, panBoundariesRadius?: number | null, panBoundariesBox?: { __typename?: 'BoundariesBox', start: { __typename?: 'RadiusVector', x: number, y: number, z: number }, end: { __typename?: 'RadiusVector', x: number, y: number, z: number } } | null } | null };

export type ShowcaseFragment = { __typename?: 'Showcase', duration?: number | null, lowBandwidth: Array<{ __typename?: 'Timecode', time: number, duration: number }> };

export type ClientFragment = { __typename?: 'Client', id: string, name: string, unrealVersion: string, hasPublicAssets: boolean };

export type SunDataFragment = { __typename?: 'Environment', udsEnabled: boolean, sunNorthYaw: number, udsHour: number };

export type CreateCameraPresetMutationVariables = Exact<{
  input: CreateCameraPresetInput;
}>;


export type CreateCameraPresetMutation = { __typename?: 'Mutation', createCameraPreset: { __typename?: 'IdOutput', id?: string | null } };

export type DeleteCameraPresetMutationVariables = Exact<{
  input: DeleteCameraPresetInput;
}>;


export type DeleteCameraPresetMutation = { __typename?: 'Mutation', deleteCameraPreset?: any | null };

export type CreateBasicConfiguratorMutationVariables = Exact<{
  input: CreateBasicConfiguratorInput;
}>;


export type CreateBasicConfiguratorMutation = { __typename?: 'Mutation', createBasicConfigurator: { __typename?: 'IdOutput', id?: string | null } };

export type DeleteBasicConfiguratorMutationVariables = Exact<{
  input: DeleteBasicConfiguratorInput;
}>;


export type DeleteBasicConfiguratorMutation = { __typename?: 'Mutation', deleteBasicConfigurator?: any | null };

export type RenameBasicConfiguratorMutationVariables = Exact<{
  input: RenameBasicConfiguratorInput;
}>;


export type RenameBasicConfiguratorMutation = { __typename?: 'Mutation', renameBasicConfigurator?: any | null };

export type ActivateBasicConfiguratorMutationVariables = Exact<{
  input: ActivateBasicConfiguratorInput;
}>;


export type ActivateBasicConfiguratorMutation = { __typename?: 'Mutation', activateBasicConfigurator?: any | null };

export type DeactivateBasicConfiguratorMutationVariables = Exact<{
  input: DeactivateBasicConfiguratorInput;
}>;


export type DeactivateBasicConfiguratorMutation = { __typename?: 'Mutation', deactivateBasicConfigurator?: any | null };

export type ChangeBasicConfiguratorProductCollectionLabelMutationVariables = Exact<{
  input: ChangeBasicConfiguratorProductCollectionLabelInput;
}>;


export type ChangeBasicConfiguratorProductCollectionLabelMutation = { __typename?: 'Mutation', changeBasicConfiguratorProductCollectionLabel?: any | null };

export type CloneBasicConfiguratorMutationVariables = Exact<{
  input: CloneBasicConfiguratorInput;
}>;


export type CloneBasicConfiguratorMutation = { __typename?: 'Mutation', cloneBasicConfigurator: { __typename?: 'IdOutput', id?: string | null } };

export type SetCameraToBasicConfiguratorMutationVariables = Exact<{
  input: SetCameraToBasicConfiguratorInput;
}>;


export type SetCameraToBasicConfiguratorMutation = { __typename?: 'Mutation', setCameraToBasicConfigurator?: any | null };

export type AddCameraToBasicConfiguratorProductMutationVariables = Exact<{
  input: AddCameraToBasicConfiguratorProductInput;
}>;


export type AddCameraToBasicConfiguratorProductMutation = { __typename?: 'Mutation', addCameraToBasicConfiguratorProduct?: any | null };

export type RemoveCameraFromBasicConfiguratorProductMutationVariables = Exact<{
  input: RemoveCameraFromBasicConfiguratorProductInput;
}>;


export type RemoveCameraFromBasicConfiguratorProductMutation = { __typename?: 'Mutation', removeCameraFromBasicConfiguratorProduct?: any | null };

export type AddEnvironmentToBasicConfiguratorMutationVariables = Exact<{
  input: AddEnvironmentToBasicConfiguratorInput;
}>;


export type AddEnvironmentToBasicConfiguratorMutation = { __typename?: 'Mutation', addEnvironmentToBasicConfigurator?: any | null };

export type RemoveEnvironmentFromBasicConfiguratorMutationVariables = Exact<{
  input: RemoveEnvironmentFromBasicConfiguratorInput;
}>;


export type RemoveEnvironmentFromBasicConfiguratorMutation = { __typename?: 'Mutation', removeEnvironmentFromBasicConfigurator?: any | null };

export type AddProductToBasicConfiguratorMutationVariables = Exact<{
  input: AddProductToBasicConfiguratorInput;
}>;


export type AddProductToBasicConfiguratorMutation = { __typename?: 'Mutation', addProductToBasicConfigurator?: any | null };

export type RemoveProductFromBasicConfiguratorMutationVariables = Exact<{
  input: RemoveProductFromBasicConfiguratorInput;
}>;


export type RemoveProductFromBasicConfiguratorMutation = { __typename?: 'Mutation', removeProductFromBasicConfigurator?: any | null };

export type ChangeBasicConfiguratorProductLabelMutationVariables = Exact<{
  input: ChangeBasicConfiguratorProductLabelInput;
}>;


export type ChangeBasicConfiguratorProductLabelMutation = { __typename?: 'Mutation', changeBasicConfiguratorProductLabel?: any | null };

export type ChangeBasicConfiguratorEnvironmentLabelMutationVariables = Exact<{
  input: ChangeBasicConfiguratorEnvironmentLabelInput;
}>;


export type ChangeBasicConfiguratorEnvironmentLabelMutation = { __typename?: 'Mutation', changeBasicConfiguratorEnvironmentLabel?: any | null };

export type ChangeBasicConfiguratorEnvironmentPositionMutationVariables = Exact<{
  input: ChangeBasicConfiguratorEnvironmentPositionInput;
}>;


export type ChangeBasicConfiguratorEnvironmentPositionMutation = { __typename?: 'Mutation', changeBasicConfiguratorEnvironmentPosition?: any | null };

export type ChangeBasicConfiguratorProductPositionMutationVariables = Exact<{
  input: ChangeBasicConfiguratorProductPositionInput;
}>;


export type ChangeBasicConfiguratorProductPositionMutation = { __typename?: 'Mutation', changeBasicConfiguratorProductPosition?: any | null };

export type CreateModularConfiguratorFromProductsMutationVariables = Exact<{
  input: CreateModularConfiguratorFromProductsInput;
}>;


export type CreateModularConfiguratorFromProductsMutation = { __typename?: 'Mutation', createModularConfiguratorFromProducts: { __typename?: 'IdOutput', id?: string | null } };

export type DeleteModularConfiguratorMutationVariables = Exact<{
  input: DeleteModularConfiguratorInput;
}>;


export type DeleteModularConfiguratorMutation = { __typename?: 'Mutation', deleteModularConfigurator?: any | null };

export type RenameModularConfiguratorMutationVariables = Exact<{
  input: RenameModularConfiguratorInput;
}>;


export type RenameModularConfiguratorMutation = { __typename?: 'Mutation', renameModularConfigurator?: any | null };

export type ActivateModularConfiguratorMutationVariables = Exact<{
  input: ActivateModularConfiguratorInput;
}>;


export type ActivateModularConfiguratorMutation = { __typename?: 'Mutation', activateModularConfigurator?: any | null };

export type DeactivateModularConfiguratorMutationVariables = Exact<{
  input: DeactivateModularConfiguratorInput;
}>;


export type DeactivateModularConfiguratorMutation = { __typename?: 'Mutation', deactivateModularConfigurator?: any | null };

export type SetCameraToModularConfiguratorMutationVariables = Exact<{
  input: SetCameraToModularConfiguratorInput;
}>;


export type SetCameraToModularConfiguratorMutation = { __typename?: 'Mutation', setCameraToModularConfigurator?: any | null };

export type AddCameraToModularConfiguratorComponentMutationVariables = Exact<{
  input: AddCameraToModularConfiguratorComponentInput;
}>;


export type AddCameraToModularConfiguratorComponentMutation = { __typename?: 'Mutation', addCameraToModularConfiguratorComponent?: any | null };

export type DeleteCameraFromModularConfiguratorComponentMutationVariables = Exact<{
  input: DeleteCameraFromModularConfiguratorComponentInput;
}>;


export type DeleteCameraFromModularConfiguratorComponentMutation = { __typename?: 'Mutation', deleteCameraFromModularConfiguratorComponent?: any | null };

export type ChangeModularConfiguratorRootComponentTypeMutationVariables = Exact<{
  input: ChangeModularConfiguratorRootComponentTypeInput;
}>;


export type ChangeModularConfiguratorRootComponentTypeMutation = { __typename?: 'Mutation', changeModularConfiguratorRootComponentType?: any | null };

export type ChangeModularConfiguratorComponentTypePositionMutationVariables = Exact<{
  input: ChangeModularConfiguratorComponentTypePositionInput;
}>;


export type ChangeModularConfiguratorComponentTypePositionMutation = { __typename?: 'Mutation', changeModularConfiguratorComponentTypePosition?: any | null };

export type AddEnvironmentToModularConfiguratorMutationVariables = Exact<{
  input: AddEnvironmentToModularConfiguratorInput;
}>;


export type AddEnvironmentToModularConfiguratorMutation = { __typename?: 'Mutation', addEnvironmentToModularConfigurator?: any | null };

export type RemoveEnvironmentFromModularConfiguratorMutationVariables = Exact<{
  input: RemoveEnvironmentFromModularConfiguratorInput;
}>;


export type RemoveEnvironmentFromModularConfiguratorMutation = { __typename?: 'Mutation', removeEnvironmentFromModularConfigurator?: any | null };

export type AddProductToModularConfiguratorMutationVariables = Exact<{
  input: AddProductToModularConfiguratorInput;
}>;


export type AddProductToModularConfiguratorMutation = { __typename?: 'Mutation', addProductToModularConfigurator: { __typename?: 'IdOutput', id?: string | null } };

export type CloneModularConfiguratorMutationVariables = Exact<{
  input: CloneModularConfiguratorInput;
}>;


export type CloneModularConfiguratorMutation = { __typename?: 'Mutation', cloneModularConfigurator: { __typename?: 'IdOutput', id?: string | null } };

export type DeleteComponentFromModularConfiguratorMutationVariables = Exact<{
  input: DeleteComponentFromModularConfiguratorInput;
}>;


export type DeleteComponentFromModularConfiguratorMutation = { __typename?: 'Mutation', deleteComponentFromModularConfigurator?: any | null };

export type RenameModularConfiguratorComponentMutationVariables = Exact<{
  input: RenameModularConfiguratorComponentInput;
}>;


export type RenameModularConfiguratorComponentMutation = { __typename?: 'Mutation', renameModularConfiguratorComponent?: any | null };

export type ChangeModularConfiguratorEnvironmentPositionMutationVariables = Exact<{
  input: ChangeModularConfiguratorEnvironmentPositionInput;
}>;


export type ChangeModularConfiguratorEnvironmentPositionMutation = { __typename?: 'Mutation', changeModularConfiguratorEnvironmentPosition?: any | null };

export type ChangeModularConfiguratorComponentPositionMutationVariables = Exact<{
  input: ChangeModularConfiguratorComponentPositionInput;
}>;


export type ChangeModularConfiguratorComponentPositionMutation = { __typename?: 'Mutation', changeModularConfiguratorComponentPosition?: any | null };

export type ChangeModularConfiguratorEnvironmentLabelMutationVariables = Exact<{
  input: ChangeModularConfiguratorEnvironmentLabelInput;
}>;


export type ChangeModularConfiguratorEnvironmentLabelMutation = { __typename?: 'Mutation', changeModularConfiguratorEnvironmentLabel?: any | null };

export type DeleteEnvironmentMutationVariables = Exact<{
  input: DeleteEnvironmentInput;
}>;


export type DeleteEnvironmentMutation = { __typename?: 'Mutation', deleteEnvironment?: any | null };

export type ChangeEnvironmentSlotLabelMutationVariables = Exact<{
  input: ChangeEnvironmentSlotLabelInput;
}>;


export type ChangeEnvironmentSlotLabelMutation = { __typename?: 'Mutation', changeEnvironmentSlotLabel?: any | null };

export type ChangeEnvironmentPreviewMutationVariables = Exact<{
  input: ChangeEnvironmentPreviewInput;
}>;


export type ChangeEnvironmentPreviewMutation = { __typename?: 'Mutation', changeEnvironmentPreview?: any | null };

export type ChangeEnvironmentTitleMutationVariables = Exact<{
  input: ChangeEnvironmentTitleInput;
}>;


export type ChangeEnvironmentTitleMutation = { __typename?: 'Mutation', changeEnvironmentTitle?: any | null };

export type EnableEnvironmentUdsMutationVariables = Exact<{
  input: EnableEnvironmentUdsInput;
}>;


export type EnableEnvironmentUdsMutation = { __typename?: 'Mutation', enableEnvironmentUds?: any | null };

export type DisableEnvironmentUdsMutationVariables = Exact<{
  input: DisableEnvironmentUdsInput;
}>;


export type DisableEnvironmentUdsMutation = { __typename?: 'Mutation', disableEnvironmentUds?: any | null };

export type ChangeEnvironmentUdsHourMutationVariables = Exact<{
  input: ChangeEnvironmentUdsHourInput;
}>;


export type ChangeEnvironmentUdsHourMutation = { __typename?: 'Mutation', changeEnvironmentUdsHour?: any | null };

export type ChangeEnvironmentSunNorthYawMutationVariables = Exact<{
  input: ChangeEnvironmentSunNorthYawInput;
}>;


export type ChangeEnvironmentSunNorthYawMutation = { __typename?: 'Mutation', changeEnvironmentSunNorthYaw?: any | null };

export type CloneEnvironmentToClientMutationVariables = Exact<{
  input: CloneEnvironmentToClientInput;
}>;


export type CloneEnvironmentToClientMutation = { __typename?: 'Mutation', cloneEnvironmentToClient: { __typename?: 'IdOutput', id?: string | null } };

export type ChangeEnvironmentPreviewFromRenderMutationVariables = Exact<{
  input: ChangeEnvironmentPreviewFromRenderInput;
}>;


export type ChangeEnvironmentPreviewFromRenderMutation = { __typename?: 'Mutation', changeEnvironmentPreviewFromRender?: any | null };

export type DeleteMaterialMutationVariables = Exact<{
  input: DeleteMaterialInput;
}>;


export type DeleteMaterialMutation = { __typename?: 'Mutation', deleteMaterial?: any | null };

export type EnableMaterialForEnvironmentSlotMutationVariables = Exact<{
  input: EnableMaterialForEnvironmentSlotInput;
}>;


export type EnableMaterialForEnvironmentSlotMutation = { __typename?: 'Mutation', enableMaterialForEnvironmentSlot?: any | null };

export type DisableMaterialForEnvironmentSlotMutationVariables = Exact<{
  input: DisableMaterialForEnvironmentSlotInput;
}>;


export type DisableMaterialForEnvironmentSlotMutation = { __typename?: 'Mutation', disableMaterialForEnvironmentSlot?: any | null };

export type EnableMaterialForProductSlotMutationVariables = Exact<{
  input: EnableMaterialForProductSlotInput;
}>;


export type EnableMaterialForProductSlotMutation = { __typename?: 'Mutation', enableMaterialForProductSlot?: any | null };

export type DisableMaterialForProductSlotMutationVariables = Exact<{
  input: DisableMaterialForProductSlotInput;
}>;


export type DisableMaterialForProductSlotMutation = { __typename?: 'Mutation', disableMaterialForProductSlot?: any | null };

export type ChangeMaterialPreviewMutationVariables = Exact<{
  input: ChangeMaterialPreviewInput;
}>;


export type ChangeMaterialPreviewMutation = { __typename?: 'Mutation', changeMaterialPreview?: any | null };

export type ChangeMaterialTitleMutationVariables = Exact<{
  input: ChangeMaterialTitleInput;
}>;


export type ChangeMaterialTitleMutation = { __typename?: 'Mutation', changeMaterialTitle?: any | null };

export type ChangeMaterialExternalIdMutationVariables = Exact<{
  input: ChangeMaterialExternalIdInput;
}>;


export type ChangeMaterialExternalIdMutation = { __typename?: 'Mutation', changeMaterialExternalId?: any | null };

export type EnableMaterialsFromAnotherEnvironmentSlotMutationVariables = Exact<{
  input: EnableMaterialsFromAnotherEnvironmentSlotInput;
}>;


export type EnableMaterialsFromAnotherEnvironmentSlotMutation = { __typename?: 'Mutation', enableMaterialsFromAnotherEnvironmentSlot?: any | null };

export type EnableMaterialsFromAnotherProductSlotMutationVariables = Exact<{
  input: EnableMaterialsFromAnotherProductSlotInput;
}>;


export type EnableMaterialsFromAnotherProductSlotMutation = { __typename?: 'Mutation', enableMaterialsFromAnotherProductSlot?: any | null };

export type DisableAllMaterialsForEnvironmentSlotMutationVariables = Exact<{
  input: DisableAllMaterialsForEnvironmentSlotInput;
}>;


export type DisableAllMaterialsForEnvironmentSlotMutation = { __typename?: 'Mutation', disableAllMaterialsForEnvironmentSlot?: any | null };

export type DisableAllMaterialsForProductSlotMutationVariables = Exact<{
  input: DisableAllMaterialsForProductSlotInput;
}>;


export type DisableAllMaterialsForProductSlotMutation = { __typename?: 'Mutation', disableAllMaterialsForProductSlot?: any | null };

export type MoveProductMaterialMutationVariables = Exact<{
  input: MoveProductMaterialInput;
}>;


export type MoveProductMaterialMutation = { __typename?: 'Mutation', moveProductMaterial?: any | null };

export type MoveEnvironmentMaterialMutationVariables = Exact<{
  input: MoveEnvironmentMaterialInput;
}>;


export type MoveEnvironmentMaterialMutation = { __typename?: 'Mutation', moveEnvironmentMaterial?: any | null };

export type CloneMaterialToClientMutationVariables = Exact<{
  input: CloneMaterialToClientInput;
}>;


export type CloneMaterialToClientMutation = { __typename?: 'Mutation', cloneMaterialToClient: { __typename?: 'IdOutput', id?: string | null } };

export type ImportProductsMetaDataMutationVariables = Exact<{
  input: ImportProductsMetaDataInput;
}>;


export type ImportProductsMetaDataMutation = { __typename?: 'Mutation', importProductsMetaData: { __typename?: 'ImportProductsMetaDataOutput', completed: boolean, warnings: Array<string> } };

export type CreateMetaPropertyMutationVariables = Exact<{
  input: CreateMetaPropertyInput;
}>;


export type CreateMetaPropertyMutation = { __typename?: 'Mutation', createMetaProperty: { __typename?: 'IdOutput', id?: string | null } };

export type DeleteMetaPropertyMutationVariables = Exact<{
  input: DeleteMetaPropertyInput;
}>;


export type DeleteMetaPropertyMutation = { __typename?: 'Mutation', deleteMetaProperty?: any | null };

export type ChangeMetaPropertyTypeMutationVariables = Exact<{
  input: ChangeMetaPropertyTypeInput;
}>;


export type ChangeMetaPropertyTypeMutation = { __typename?: 'Mutation', changeMetaPropertyType?: any | null };

export type CreatePresetMutationVariables = Exact<{
  input: CreatePresetInput;
}>;


export type CreatePresetMutation = { __typename?: 'Mutation', createPreset: { __typename?: 'Preset', id: string, title: string, config: string, createdAt: string, previewPath?: string | null } };

export type DeletePresetMutationVariables = Exact<{
  input: DeletePresetInput;
}>;


export type DeletePresetMutation = { __typename?: 'Mutation', deletePreset?: any | null };

export type ChangeProductExternalIdMutationVariables = Exact<{
  input: ChangeProductExternalIdInput;
}>;


export type ChangeProductExternalIdMutation = { __typename?: 'Mutation', changeProductExternalId?: any | null };

export type ChangeProductPreviewMutationVariables = Exact<{
  input: ChangeProductPreviewInput;
}>;


export type ChangeProductPreviewMutation = { __typename?: 'Mutation', changeProductPreview?: any | null };

export type ChangeProductTitleMutationVariables = Exact<{
  input: ChangeProductTitleInput;
}>;


export type ChangeProductTitleMutation = { __typename?: 'Mutation', changeProductTitle?: any | null };

export type DeleteProductMutationVariables = Exact<{
  input: DeleteProductInput;
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct?: any | null };

export type ChangeProductSlotLabelMutationVariables = Exact<{
  input: ChangeProductSlotLabelInput;
}>;


export type ChangeProductSlotLabelMutation = { __typename?: 'Mutation', changeProductSlotLabel?: any | null };

export type SetProductLowBandwidthTimecodesMutationVariables = Exact<{
  input: SetProductLowBandwidthTimecodesInput;
}>;


export type SetProductLowBandwidthTimecodesMutation = { __typename?: 'Mutation', setProductLowBandwidthTimecodes?: any | null };

export type CloneProductToClientMutationVariables = Exact<{
  input: CloneProductToClientInput;
}>;


export type CloneProductToClientMutation = { __typename?: 'Mutation', cloneProductToClient: { __typename?: 'IdOutput', id?: string | null } };

export type ChangeProductPreviewFromRenderMutationVariables = Exact<{
  input: ChangeProductPreviewFromRenderInput;
}>;


export type ChangeProductPreviewFromRenderMutation = { __typename?: 'Mutation', changeProductPreviewFromRender?: any | null };

export type CreateRenderRequestMutationVariables = Exact<{
  input: CreateRenderRequestInput;
}>;


export type CreateRenderRequestMutation = { __typename?: 'Mutation', createRenderRequest: { __typename?: 'IdOutput', id?: string | null } };

export type DeleteRenderMutationVariables = Exact<{
  input: DeleteRenderInput;
}>;


export type DeleteRenderMutation = { __typename?: 'Mutation', deleteRender?: any | null };

export type CreateSpinnerRequestMutationVariables = Exact<{
  input: CreateSpinnerRequestInput;
}>;


export type CreateSpinnerRequestMutation = { __typename?: 'Mutation', createSpinnerRequest: { __typename?: 'SpinnerRequest', id: string, spinnerId: string, status: RequestStatusEnum, uploadUrl: string } };

export type DeleteSpinnerMutationVariables = Exact<{
  input: DeleteSpinnerInput;
}>;


export type DeleteSpinnerMutation = { __typename?: 'Mutation', deleteSpinner?: any | null };

export type CreateAssetCreationRequestMutationVariables = Exact<{
  input: CreateAssetCreationRequestInput;
}>;


export type CreateAssetCreationRequestMutation = { __typename?: 'Mutation', createAssetCreationRequest: { __typename?: 'CreateAssetCreationRequestOutput', completed: boolean } };

export type ClientQueryVariables = Exact<{
  input: GetClientInput;
}>;


export type ClientQuery = { __typename?: 'Query', client: { __typename?: 'Client', hasPublicAssets: boolean } };

export type ClientListQueryVariables = Exact<{
  input: GetClientListInput;
}>;


export type ClientListQuery = { __typename?: 'Query', clientList: { __typename?: 'GetClientListOutput', limit?: number | null, offset?: number | null, total?: number | null, clients: Array<{ __typename?: 'Client', id: string, name: string, unrealVersion: string, hasPublicAssets: boolean }> } };

export type BasicConfiguratorListQueryVariables = Exact<{
  input: GetBasicConfiguratorListInput;
}>;


export type BasicConfiguratorListQuery = { __typename?: 'Query', basicConfiguratorList: { __typename?: 'GetBasicConfiguratorListOutput', limit?: number | null, total?: number | null, offset?: number | null, basicConfigurators: Array<{ __typename?: 'BasicConfigurator', id: string, name: string, isActive: boolean, ctaEnabled?: boolean | null, environments: Array<{ __typename?: 'BasicConfiguratorEnvironment', environmentId: string, label: string, environment: { __typename?: 'Environment', title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }> } }>, products: Array<{ __typename?: 'BasicConfiguratorProduct', productId: string, label: string, product: { __typename?: 'Product', externalId?: string | null, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }> } }> }> } };

export type BasicConfiguratorEnvironmentsQueryVariables = Exact<{
  input: GetBasicConfiguratorInput;
}>;


export type BasicConfiguratorEnvironmentsQuery = { __typename?: 'Query', basicConfigurator: { __typename?: 'BasicConfigurator', id: string, environments: Array<{ __typename?: 'BasicConfiguratorEnvironment', environmentId: string, position: number, label: string, environment: { __typename?: 'Environment', title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }> } }> } };

export type BasicConfiguratorProductsQueryVariables = Exact<{
  input: GetBasicConfiguratorInput;
}>;


export type BasicConfiguratorProductsQuery = { __typename?: 'Query', basicConfigurator: { __typename?: 'BasicConfigurator', id: string, products: Array<{ __typename?: 'BasicConfiguratorProduct', productId: string, position: number, label: string, camera?: { __typename?: 'Camera', mode: string, fov: number, position: { __typename?: 'RadiusVector', x: number, y: number, z: number }, rotation: { __typename?: 'Rotation', pitch: number, yaw: number, roll: number }, restrictions?: { __typename?: 'Restrictions', maxZoom?: number | null, minZoom?: number | null, minPitch?: number | null, maxPitch?: number | null, maxYaw?: number | null, minYaw?: number | null, panBoundariesRadius?: number | null, panBoundariesBox?: { __typename?: 'BoundariesBox', start: { __typename?: 'RadiusVector', x: number, y: number, z: number }, end: { __typename?: 'RadiusVector', x: number, y: number, z: number } } | null } | null } | null, product: { __typename?: 'Product', externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }> } }> } };

export type ModularConfiguratorListQueryVariables = Exact<{
  input: GetModularConfiguratorListInput;
}>;


export type ModularConfiguratorListQuery = { __typename?: 'Query', modularConfiguratorList: { __typename?: 'GetModularConfiguratorListOutput', limit: number, total?: number | null, offset: number, modularConfigurators: Array<{ __typename?: 'ModularConfigurator', id: string, name: string, isActive: boolean, ctaEnabled?: boolean | null, environments: Array<{ __typename?: 'ModularConfiguratorEnvironment', environmentId: string, environment: { __typename?: 'Environment', title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }> } }>, components: Array<{ __typename?: 'ModularConfiguratorComponent', id: string, name: string, position: number, componentType?: { __typename?: 'ModularConfiguratorComponentType', id: string, name: string, position: number, isRoot: boolean, isRequired: boolean } | null, product: { __typename?: 'Product', id: string, title: string, externalId?: string | null, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }> } }> }> } };

export type ModularConfiguratorEnvironmentsQueryVariables = Exact<{
  input: GetModularConfiguratorInput;
}>;


export type ModularConfiguratorEnvironmentsQuery = { __typename?: 'Query', modularConfigurator: { __typename?: 'ModularConfigurator', id: string, environments: Array<{ __typename?: 'ModularConfiguratorEnvironment', environmentId: string, position: number, label: string, environment: { __typename?: 'Environment', title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }> } }> } };

export type ModularConfiguratorComponentsQueryVariables = Exact<{
  input: GetModularConfiguratorInput;
}>;


export type ModularConfiguratorComponentsQuery = { __typename?: 'Query', modularConfigurator: { __typename?: 'ModularConfigurator', id: string, componentTypes: Array<{ __typename?: 'ModularConfiguratorComponentType', id: string, name: string, position: number, isRoot: boolean, isRequired: boolean }>, components: Array<{ __typename?: 'ModularConfiguratorComponent', id: string, name: string, position: number, componentType?: { __typename?: 'ModularConfiguratorComponentType', name: string, position: number, isRoot: boolean, isRequired: boolean, id: string } | null, camera?: { __typename?: 'Camera', mode: string, fov: number, position: { __typename?: 'RadiusVector', x: number, y: number, z: number }, rotation: { __typename?: 'Rotation', pitch: number, yaw: number, roll: number }, restrictions?: { __typename?: 'Restrictions', maxZoom?: number | null, minZoom?: number | null, minPitch?: number | null, maxPitch?: number | null, maxYaw?: number | null, minYaw?: number | null, panBoundariesRadius?: number | null, panBoundariesBox?: { __typename?: 'BoundariesBox', start: { __typename?: 'RadiusVector', x: number, y: number, z: number }, end: { __typename?: 'RadiusVector', x: number, y: number, z: number } } | null } | null } | null, product: { __typename?: 'Product', clientId: string, title: string, externalId?: string | null, id: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string }, showcase?: { __typename?: 'Showcase', duration?: number | null, lowBandwidth: Array<{ __typename?: 'Timecode', time: number, duration: number }> } | null } }> } };

export type BasicConfiguratorQueryVariables = Exact<{
  input: GetBasicConfiguratorInput;
}>;


export type BasicConfiguratorQuery = { __typename?: 'Query', basicConfigurator: { __typename?: 'BasicConfigurator', id: string, isActive: boolean, ctaEnabled?: boolean | null, productCollectionLabel: string, name: string, camera: { __typename?: 'Camera', mode: string, fov: number, position: { __typename?: 'RadiusVector', x: number, y: number, z: number }, rotation: { __typename?: 'Rotation', pitch: number, yaw: number, roll: number }, restrictions?: { __typename?: 'Restrictions', maxZoom?: number | null, minZoom?: number | null, minPitch?: number | null, maxPitch?: number | null, maxYaw?: number | null, minYaw?: number | null, panBoundariesRadius?: number | null, panBoundariesBox?: { __typename?: 'BoundariesBox', start: { __typename?: 'RadiusVector', x: number, y: number, z: number }, end: { __typename?: 'RadiusVector', x: number, y: number, z: number } } | null } | null }, client: { __typename?: 'Client', id: string, name: string, unrealVersion: string, hasPublicAssets: boolean }, products: Array<{ __typename?: 'BasicConfiguratorProduct', productId: string, position: number, label: string, camera?: { __typename?: 'Camera', mode: string, fov: number, position: { __typename?: 'RadiusVector', x: number, y: number, z: number }, rotation: { __typename?: 'Rotation', pitch: number, yaw: number, roll: number }, restrictions?: { __typename?: 'Restrictions', maxZoom?: number | null, minZoom?: number | null, minPitch?: number | null, maxPitch?: number | null, maxYaw?: number | null, minYaw?: number | null, panBoundariesRadius?: number | null, panBoundariesBox?: { __typename?: 'BoundariesBox', start: { __typename?: 'RadiusVector', x: number, y: number, z: number }, end: { __typename?: 'RadiusVector', x: number, y: number, z: number } } | null } | null } | null, product: { __typename?: 'Product', externalId?: string | null, title: string, id: string, metaProperties: Array<{ __typename?: 'ProductMetaProperty', id: string, value: string, type: string, name: string }>, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string }, showcase?: { __typename?: 'Showcase', duration?: number | null, lowBandwidth: Array<{ __typename?: 'Timecode', time: number, duration: number }> } | null } }>, environments: Array<{ __typename?: 'BasicConfiguratorEnvironment', environmentId: string, position: number, label: string, environment: { __typename?: 'Environment', id: string, title: string, udsEnabled: boolean, sunNorthYaw: number, udsHour: number, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } } }> } };

export type ModularConfiguratorQueryVariables = Exact<{
  input: GetModularConfiguratorInput;
}>;


export type ModularConfiguratorQuery = { __typename?: 'Query', modularConfigurator: { __typename?: 'ModularConfigurator', id: string, isActive: boolean, ctaEnabled?: boolean | null, name: string, camera: { __typename?: 'Camera', mode: string, fov: number, position: { __typename?: 'RadiusVector', x: number, y: number, z: number }, rotation: { __typename?: 'Rotation', pitch: number, yaw: number, roll: number }, restrictions?: { __typename?: 'Restrictions', maxZoom?: number | null, minZoom?: number | null, minPitch?: number | null, maxPitch?: number | null, maxYaw?: number | null, minYaw?: number | null, panBoundariesRadius?: number | null, panBoundariesBox?: { __typename?: 'BoundariesBox', start: { __typename?: 'RadiusVector', x: number, y: number, z: number }, end: { __typename?: 'RadiusVector', x: number, y: number, z: number } } | null } | null }, client: { __typename?: 'Client', id: string, name: string, unrealVersion: string, hasPublicAssets: boolean }, componentTypes: Array<{ __typename?: 'ModularConfiguratorComponentType', name: string, position: number, isRoot: boolean, isRequired: boolean, id: string }>, connectors: Array<{ __typename?: 'ModularConfiguratorConnector', id: string, componentTypeId1: string, componentTypeId2: string }>, components: Array<{ __typename?: 'ModularConfiguratorComponent', id: string, name: string, position: number, componentType?: { __typename?: 'ModularConfiguratorComponentType', name: string, position: number, isRoot: boolean, isRequired: boolean, id: string } | null, virtualSocketToConnectorsMap: Array<{ __typename?: 'ModularConfiguratorVirtualSocketToConnector', virtualSocketId: string, connectorId: string }>, camera?: { __typename?: 'Camera', mode: string, fov: number, position: { __typename?: 'RadiusVector', x: number, y: number, z: number }, rotation: { __typename?: 'Rotation', pitch: number, yaw: number, roll: number }, restrictions?: { __typename?: 'Restrictions', maxZoom?: number | null, minZoom?: number | null, minPitch?: number | null, maxPitch?: number | null, maxYaw?: number | null, minYaw?: number | null, panBoundariesRadius?: number | null, panBoundariesBox?: { __typename?: 'BoundariesBox', start: { __typename?: 'RadiusVector', x: number, y: number, z: number }, end: { __typename?: 'RadiusVector', x: number, y: number, z: number } } | null } | null } | null, product: { __typename?: 'Product', externalId?: string | null, title: string, id: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, metaProperties: Array<{ __typename?: 'ProductMetaProperty', id: string, value: string, type: string, name: string }>, virtualSockets: Array<{ __typename?: 'VirtualSocket', id: string, name: string, originalSockets: Array<string> }>, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string }, showcase?: { __typename?: 'Showcase', duration?: number | null, lowBandwidth: Array<{ __typename?: 'Timecode', time: number, duration: number }> } | null } }>, environments: Array<{ __typename?: 'ModularConfiguratorEnvironment', environmentId: string, position: number, label: string, environment: { __typename?: 'Environment', id: string, title: string, udsEnabled: boolean, sunNorthYaw: number, udsHour: number, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } } }> } };

export type EnvironmentQueryVariables = Exact<{
  input: GetEnvironmentInput;
}>;


export type EnvironmentQuery = { __typename?: 'Query', environment: { __typename: 'Environment', id: string, title: string, clientId: string, udsEnabled: boolean, sunNorthYaw: number, udsHour: number, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string }, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }> } };

export type EnvironmentWithClientAndUVersionQueryVariables = Exact<{
  input: GetEnvironmentInput;
}>;


export type EnvironmentWithClientAndUVersionQuery = { __typename?: 'Query', environment: { __typename?: 'Environment', id: string, clientId: string, udsEnabled: boolean, sunNorthYaw: number, udsHour: number, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } } };

export type EnvironmentListQueryVariables = Exact<{
  input: GetEnvironmentListInput;
}>;


export type EnvironmentListQuery = { __typename?: 'Query', environmentList: { __typename?: 'GetEnvironmentListOutput', limit?: number | null, total?: number | null, offset?: number | null, environments: Array<{ __typename?: 'Environment', id: string, legacyAssetId: string, title: string, udsEnabled: boolean, sunNorthYaw: number, udsHour: number, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string }, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }> }> } };

export type EnvironmentRendersQueryVariables = Exact<{
  input: GetEnvironmentInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EnvironmentRendersQuery = { __typename?: 'Query', environment: { __typename?: 'Environment', id: string, renders: { __typename?: 'RenderListType', limit?: number | null, total?: number | null, offset?: number | null, renders: Array<{ __typename?: 'Render', id: string, filePath: string, renderRequest: { __typename?: 'RenderRequest', id: string, previewPath?: string | null, serialNumber: number, createdAt?: string | null, status: RequestStatusEnum } }> } } };

export type EnvironmentRendersDownloadQueryVariables = Exact<{
  input: GetEnvironmentInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EnvironmentRendersDownloadQuery = { __typename?: 'Query', environment: { __typename?: 'Environment', id: string, title: string, renders: { __typename?: 'RenderListType', renders: Array<{ __typename?: 'Render', id: string }> } } };

export type EnvironmentCameraPresetsQueryVariables = Exact<{
  input: GetEnvironmentInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EnvironmentCameraPresetsQuery = { __typename?: 'Query', environment: { __typename?: 'Environment', id: string, title: string, cameraPresets: { __typename?: 'CameraPresetListType', limit?: number | null, total?: number | null, offset?: number | null, cameraPresets: Array<{ __typename?: 'CameraPreset', id: string, config: string, previewPath?: string | null, isLocked: boolean, title: string }> } } };

export type EnvironmentMaterialsQueryVariables = Exact<{
  input: GetEnvironmentInput;
}>;


export type EnvironmentMaterialsQuery = { __typename?: 'Query', environment: { __typename?: 'Environment', id: string, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }> } };

export type MaterialQueryVariables = Exact<{
  input: GetMaterialInput;
}>;


export type MaterialQuery = { __typename?: 'Query', material: { __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }> } };

export type MaterialListQueryVariables = Exact<{
  input: GetMaterialListInput;
}>;


export type MaterialListQuery = { __typename?: 'Query', materialList: { __typename?: 'GetMaterialListOutput', limit?: number | null, total?: number | null, offset?: number | null, materials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }> }> } };

export type MetaPropertyListQueryVariables = Exact<{
  input: GetMetaPropertyListInput;
}>;


export type MetaPropertyListQuery = { __typename?: 'Query', metaPropertyList: { __typename?: 'GetMetaPropertyListOutput', limit?: number | null, total?: number | null, offset?: number | null, metaProperties: Array<{ __typename?: 'MetaProperty', id: string, name: string, type: string, expression?: string | null }> } };

export type PresetListQueryVariables = Exact<{
  input: GetPresetListInput;
}>;


export type PresetListQuery = { __typename?: 'Query', presetList: { __typename?: 'GetPresetListOutput', limit?: number | null, total?: number | null, offset?: number | null, presets: Array<{ __typename?: 'Preset', id: string, title: string, config: string, previewPath?: string | null, createdAt: string, environment: { __typename?: 'Environment', id: string, title: string, clientId: string, udsEnabled: boolean, sunNorthYaw: number, udsHour: number, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string }, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }> } }> } };

export type PresetCategoriesQueryVariables = Exact<{
  input: GetEnvironmentListInput;
}>;


export type PresetCategoriesQuery = { __typename?: 'Query', environmentList: { __typename?: 'GetEnvironmentListOutput', environments: Array<{ __typename?: 'Environment', id: string, title: string }> } };

export type ProductQueryVariables = Exact<{
  input: GetProductInput;
}>;


export type ProductQuery = { __typename?: 'Query', product: { __typename: 'Product', id: string, externalId?: string | null, title: string, showcase?: { __typename?: 'Showcase', duration?: number | null, lowBandwidth: Array<{ __typename?: 'Timecode', time: number, duration: number }> } | null, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } } };

export type ProductWithClientAndUVersionQueryVariables = Exact<{
  input: GetProductInput;
}>;


export type ProductWithClientAndUVersionQuery = { __typename?: 'Query', product: { __typename: 'Product', id: string, clientId: string, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string }, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }> } };

export type ProductListQueryVariables = Exact<{
  input: GetProductListInput;
}>;


export type ProductListQuery = { __typename?: 'Query', productList: { __typename?: 'GetProductListOutput', limit?: number | null, total?: number | null, offset?: number | null, products: Array<{ __typename?: 'Product', legacyAssetId: string, id: string, clientId: string, title: string, externalId?: string | null, virtualSockets: Array<{ __typename?: 'VirtualSocket', id: string, name: string }>, productType?: { __typename?: 'ProductType', id: string, name: string } | null, showcase?: { __typename?: 'Showcase', duration?: number | null, lowBandwidth: Array<{ __typename?: 'Timecode', time: number, duration: number }> } | null, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string }, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }> }> } };

export type ProductRendersQueryVariables = Exact<{
  input: GetProductInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductRendersQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, renders: { __typename?: 'RenderListType', limit?: number | null, total?: number | null, offset?: number | null, renders: Array<{ __typename?: 'Render', id: string, filePath: string, renderRequest: { __typename?: 'RenderRequest', id: string, previewPath?: string | null, serialNumber: number, createdAt?: string | null, status: RequestStatusEnum } }> } } };

export type ProductSpinnersQueryVariables = Exact<{
  input: GetProductInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductSpinnersQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, spinners: { __typename?: 'SpinnerListType', limit?: number | null, total?: number | null, offset?: number | null, spinners: Array<{ __typename?: 'Spinner', id: string, path: string, template: string, startX: number, endX: number, defaultX: number, maskX: string, status: RequestStatusEnum }> } } };

export type ProductRendersSpinnersDownloadQueryVariables = Exact<{
  input: GetProductInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductRendersSpinnersDownloadQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, title: string, renders: { __typename?: 'RenderListType', renders: Array<{ __typename?: 'Render', id: string }> }, spinners: { __typename?: 'SpinnerListType', spinners: Array<{ __typename?: 'Spinner', id: string }> } } };

export type ProductCameraPresetsQueryVariables = Exact<{
  input: GetProductInput;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductCameraPresetsQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, title: string, cameraPresets: { __typename?: 'CameraPresetListType', limit?: number | null, total?: number | null, offset?: number | null, cameraPresets: Array<{ __typename?: 'CameraPreset', id: string, config: string, previewPath?: string | null, isLocked: boolean, title: string }> } } };

export type ProductMaterialsQueryVariables = Exact<{
  input: GetProductInput;
}>;


export type ProductMaterialsQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }> } };

export type RenderListQueryVariables = Exact<{
  input: GetRenderListInput;
}>;


export type RenderListQuery = { __typename?: 'Query', renderList: { __typename?: 'RenderListType', limit?: number | null, total?: number | null, offset?: number | null, renders: Array<{ __typename?: 'Render', id: string, filePath: string, renderRequest: { __typename?: 'RenderRequest', id: string, previewPath?: string | null, serialNumber: number, createdAt?: string | null, status: RequestStatusEnum, email?: string | null, fileType: RenderRequestFileTypeEnum, height: number, width: number, fov: number, author?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null } }> } };

export type RenderQueryVariables = Exact<{
  input: GetRenderInput;
}>;


export type RenderQuery = { __typename?: 'Query', render: { __typename?: 'Render', id: string, filePath: string, fullSizePreviewPath: string, fileSize: number, renderRequest: { __typename?: 'RenderRequest', id: string, previewPath?: string | null, serialNumber: number, configuration?: string | null, email?: string | null, height: number, width: number, fov: number, fileType: RenderRequestFileTypeEnum, status: RequestStatusEnum, createdAt?: string | null, author?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null, products: Array<{ __typename?: 'Product', id: string, legacyAssetId: string, externalId?: string | null, title: string, showcase?: { __typename?: 'Showcase', duration?: number | null, lowBandwidth: Array<{ __typename?: 'Timecode', time: number, duration: number }> } | null, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }>, environment?: { __typename?: 'Environment', id: string, legacyAssetId: string, title: string, clientId: string, udsEnabled: boolean, sunNorthYaw: number, udsHour: number, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string }, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, slots: Array<{ __typename?: 'Slot', id: string, label: string, enabledMaterials: Array<{ __typename?: 'Material', id: string, externalId?: string | null, title: string, thumbnailList: Array<{ __typename?: 'Thumbnail', width: number, height: number, urlPath: string }>, model: { __typename?: 'Model', id: string, pakFilePath: string, assetPath: string, unrealVersion: string } }> }> } | null } } };

export type RenderRequestParamsQueryVariables = Exact<{
  input: GetRenderRequestInput;
}>;


export type RenderRequestParamsQuery = { __typename?: 'Query', renderRequest: { __typename?: 'RenderRequest', id: string, renderResultUrl: string, renderId?: string | null, status: RequestStatusEnum } };

export type SpinnerQueryVariables = Exact<{
  input: GetSpinnerInput;
}>;


export type SpinnerQuery = { __typename?: 'Query', spinner: { __typename?: 'Spinner', id: string, path: string, template: string, startX: number, endX: number, defaultX: number, maskX: string, status: RequestStatusEnum } };

export type AssetCreationRequestListQueryVariables = Exact<{
  input: GetAssetCreationRequestListInput;
}>;


export type AssetCreationRequestListQuery = { __typename?: 'Query', assetCreationRequestList: { __typename?: 'GetAssetCreationRequestListOutput', assetCreationRequests: Array<{ __typename?: 'AssetCreationRequest', id: string, status: AssetCreationRequestStatus, assetType?: AssetType | null, assetId?: string | null, errors?: Array<string> | null }> } };

export const SpinnerFragmentDoc = gql`
    fragment Spinner on Spinner {
  id
  path
  template
  startX
  endX
  defaultX
  maskX
  status
}
    `;
export const ThumbnailFragmentDoc = gql`
    fragment Thumbnail on Thumbnail {
  width
  height
  urlPath
}
    `;
export const ModelFragmentDoc = gql`
    fragment Model on Model {
  id
  pakFilePath
  assetPath
  unrealVersion
}
    `;
export const SlotDataFragmentDoc = gql`
    fragment SlotData on Slot {
  id
  label
  enabledMaterials {
    id
    externalId
    title
    thumbnailList {
      ...Thumbnail
    }
    model {
      ...Model
    }
  }
}
    ${ThumbnailFragmentDoc}
${ModelFragmentDoc}`;
export const RadiusVectorFragmentDoc = gql`
    fragment RadiusVector on RadiusVector {
  x
  y
  z
}
    `;
export const RotationFragmentDoc = gql`
    fragment Rotation on Rotation {
  pitch
  yaw
  roll
}
    `;
export const RestrictionsFragmentDoc = gql`
    fragment Restrictions on Restrictions {
  maxZoom
  minZoom
  minPitch
  maxPitch
  maxYaw
  minYaw
  panBoundariesRadius
  panBoundariesBox {
    start {
      ...RadiusVector
    }
    end {
      ...RadiusVector
    }
  }
}
    ${RadiusVectorFragmentDoc}`;
export const CameraFragmentDoc = gql`
    fragment Camera on Camera {
  mode
  fov
  position {
    ...RadiusVector
  }
  rotation {
    ...Rotation
  }
  restrictions {
    ...Restrictions
  }
}
    ${RadiusVectorFragmentDoc}
${RotationFragmentDoc}
${RestrictionsFragmentDoc}`;
export const ShowcaseFragmentDoc = gql`
    fragment Showcase on Showcase {
  lowBandwidth {
    time
    duration
  }
  duration
}
    `;
export const ClientFragmentDoc = gql`
    fragment Client on Client {
  id
  name
  unrealVersion
  hasPublicAssets
}
    `;
export const SunDataFragmentDoc = gql`
    fragment SunData on Environment {
  udsEnabled
  sunNorthYaw
  udsHour
}
    `;
export const CreateCameraPresetDocument = gql`
    mutation createCameraPreset($input: CreateCameraPresetInput!) {
  createCameraPreset(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCameraPresetGQL extends Apollo.Mutation<CreateCameraPresetMutation, CreateCameraPresetMutationVariables> {
    document = CreateCameraPresetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCameraPresetDocument = gql`
    mutation deleteCameraPreset($input: DeleteCameraPresetInput!) {
  deleteCameraPreset(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCameraPresetGQL extends Apollo.Mutation<DeleteCameraPresetMutation, DeleteCameraPresetMutationVariables> {
    document = DeleteCameraPresetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBasicConfiguratorDocument = gql`
    mutation createBasicConfigurator($input: CreateBasicConfiguratorInput!) {
  createBasicConfigurator(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBasicConfiguratorGQL extends Apollo.Mutation<CreateBasicConfiguratorMutation, CreateBasicConfiguratorMutationVariables> {
    document = CreateBasicConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteBasicConfiguratorDocument = gql`
    mutation deleteBasicConfigurator($input: DeleteBasicConfiguratorInput!) {
  deleteBasicConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteBasicConfiguratorGQL extends Apollo.Mutation<DeleteBasicConfiguratorMutation, DeleteBasicConfiguratorMutationVariables> {
    document = DeleteBasicConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RenameBasicConfiguratorDocument = gql`
    mutation renameBasicConfigurator($input: RenameBasicConfiguratorInput!) {
  renameBasicConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RenameBasicConfiguratorGQL extends Apollo.Mutation<RenameBasicConfiguratorMutation, RenameBasicConfiguratorMutationVariables> {
    document = RenameBasicConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActivateBasicConfiguratorDocument = gql`
    mutation activateBasicConfigurator($input: ActivateBasicConfiguratorInput!) {
  activateBasicConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActivateBasicConfiguratorGQL extends Apollo.Mutation<ActivateBasicConfiguratorMutation, ActivateBasicConfiguratorMutationVariables> {
    document = ActivateBasicConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeactivateBasicConfiguratorDocument = gql`
    mutation deactivateBasicConfigurator($input: DeactivateBasicConfiguratorInput!) {
  deactivateBasicConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeactivateBasicConfiguratorGQL extends Apollo.Mutation<DeactivateBasicConfiguratorMutation, DeactivateBasicConfiguratorMutationVariables> {
    document = DeactivateBasicConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeBasicConfiguratorProductCollectionLabelDocument = gql`
    mutation changeBasicConfiguratorProductCollectionLabel($input: ChangeBasicConfiguratorProductCollectionLabelInput!) {
  changeBasicConfiguratorProductCollectionLabel(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeBasicConfiguratorProductCollectionLabelGQL extends Apollo.Mutation<ChangeBasicConfiguratorProductCollectionLabelMutation, ChangeBasicConfiguratorProductCollectionLabelMutationVariables> {
    document = ChangeBasicConfiguratorProductCollectionLabelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CloneBasicConfiguratorDocument = gql`
    mutation cloneBasicConfigurator($input: CloneBasicConfiguratorInput!) {
  cloneBasicConfigurator(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CloneBasicConfiguratorGQL extends Apollo.Mutation<CloneBasicConfiguratorMutation, CloneBasicConfiguratorMutationVariables> {
    document = CloneBasicConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetCameraToBasicConfiguratorDocument = gql`
    mutation setCameraToBasicConfigurator($input: SetCameraToBasicConfiguratorInput!) {
  setCameraToBasicConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetCameraToBasicConfiguratorGQL extends Apollo.Mutation<SetCameraToBasicConfiguratorMutation, SetCameraToBasicConfiguratorMutationVariables> {
    document = SetCameraToBasicConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddCameraToBasicConfiguratorProductDocument = gql`
    mutation addCameraToBasicConfiguratorProduct($input: AddCameraToBasicConfiguratorProductInput!) {
  addCameraToBasicConfiguratorProduct(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCameraToBasicConfiguratorProductGQL extends Apollo.Mutation<AddCameraToBasicConfiguratorProductMutation, AddCameraToBasicConfiguratorProductMutationVariables> {
    document = AddCameraToBasicConfiguratorProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCameraFromBasicConfiguratorProductDocument = gql`
    mutation removeCameraFromBasicConfiguratorProduct($input: RemoveCameraFromBasicConfiguratorProductInput!) {
  removeCameraFromBasicConfiguratorProduct(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCameraFromBasicConfiguratorProductGQL extends Apollo.Mutation<RemoveCameraFromBasicConfiguratorProductMutation, RemoveCameraFromBasicConfiguratorProductMutationVariables> {
    document = RemoveCameraFromBasicConfiguratorProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddEnvironmentToBasicConfiguratorDocument = gql`
    mutation addEnvironmentToBasicConfigurator($input: AddEnvironmentToBasicConfiguratorInput!) {
  addEnvironmentToBasicConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddEnvironmentToBasicConfiguratorGQL extends Apollo.Mutation<AddEnvironmentToBasicConfiguratorMutation, AddEnvironmentToBasicConfiguratorMutationVariables> {
    document = AddEnvironmentToBasicConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveEnvironmentFromBasicConfiguratorDocument = gql`
    mutation removeEnvironmentFromBasicConfigurator($input: RemoveEnvironmentFromBasicConfiguratorInput!) {
  removeEnvironmentFromBasicConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveEnvironmentFromBasicConfiguratorGQL extends Apollo.Mutation<RemoveEnvironmentFromBasicConfiguratorMutation, RemoveEnvironmentFromBasicConfiguratorMutationVariables> {
    document = RemoveEnvironmentFromBasicConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddProductToBasicConfiguratorDocument = gql`
    mutation addProductToBasicConfigurator($input: AddProductToBasicConfiguratorInput!) {
  addProductToBasicConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddProductToBasicConfiguratorGQL extends Apollo.Mutation<AddProductToBasicConfiguratorMutation, AddProductToBasicConfiguratorMutationVariables> {
    document = AddProductToBasicConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveProductFromBasicConfiguratorDocument = gql`
    mutation removeProductFromBasicConfigurator($input: RemoveProductFromBasicConfiguratorInput!) {
  removeProductFromBasicConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveProductFromBasicConfiguratorGQL extends Apollo.Mutation<RemoveProductFromBasicConfiguratorMutation, RemoveProductFromBasicConfiguratorMutationVariables> {
    document = RemoveProductFromBasicConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeBasicConfiguratorProductLabelDocument = gql`
    mutation changeBasicConfiguratorProductLabel($input: ChangeBasicConfiguratorProductLabelInput!) {
  changeBasicConfiguratorProductLabel(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeBasicConfiguratorProductLabelGQL extends Apollo.Mutation<ChangeBasicConfiguratorProductLabelMutation, ChangeBasicConfiguratorProductLabelMutationVariables> {
    document = ChangeBasicConfiguratorProductLabelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeBasicConfiguratorEnvironmentLabelDocument = gql`
    mutation changeBasicConfiguratorEnvironmentLabel($input: ChangeBasicConfiguratorEnvironmentLabelInput!) {
  changeBasicConfiguratorEnvironmentLabel(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeBasicConfiguratorEnvironmentLabelGQL extends Apollo.Mutation<ChangeBasicConfiguratorEnvironmentLabelMutation, ChangeBasicConfiguratorEnvironmentLabelMutationVariables> {
    document = ChangeBasicConfiguratorEnvironmentLabelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeBasicConfiguratorEnvironmentPositionDocument = gql`
    mutation changeBasicConfiguratorEnvironmentPosition($input: ChangeBasicConfiguratorEnvironmentPositionInput!) {
  changeBasicConfiguratorEnvironmentPosition(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeBasicConfiguratorEnvironmentPositionGQL extends Apollo.Mutation<ChangeBasicConfiguratorEnvironmentPositionMutation, ChangeBasicConfiguratorEnvironmentPositionMutationVariables> {
    document = ChangeBasicConfiguratorEnvironmentPositionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeBasicConfiguratorProductPositionDocument = gql`
    mutation changeBasicConfiguratorProductPosition($input: ChangeBasicConfiguratorProductPositionInput!) {
  changeBasicConfiguratorProductPosition(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeBasicConfiguratorProductPositionGQL extends Apollo.Mutation<ChangeBasicConfiguratorProductPositionMutation, ChangeBasicConfiguratorProductPositionMutationVariables> {
    document = ChangeBasicConfiguratorProductPositionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateModularConfiguratorFromProductsDocument = gql`
    mutation createModularConfiguratorFromProducts($input: CreateModularConfiguratorFromProductsInput!) {
  createModularConfiguratorFromProducts(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateModularConfiguratorFromProductsGQL extends Apollo.Mutation<CreateModularConfiguratorFromProductsMutation, CreateModularConfiguratorFromProductsMutationVariables> {
    document = CreateModularConfiguratorFromProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteModularConfiguratorDocument = gql`
    mutation deleteModularConfigurator($input: DeleteModularConfiguratorInput!) {
  deleteModularConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteModularConfiguratorGQL extends Apollo.Mutation<DeleteModularConfiguratorMutation, DeleteModularConfiguratorMutationVariables> {
    document = DeleteModularConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RenameModularConfiguratorDocument = gql`
    mutation renameModularConfigurator($input: RenameModularConfiguratorInput!) {
  renameModularConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RenameModularConfiguratorGQL extends Apollo.Mutation<RenameModularConfiguratorMutation, RenameModularConfiguratorMutationVariables> {
    document = RenameModularConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActivateModularConfiguratorDocument = gql`
    mutation activateModularConfigurator($input: ActivateModularConfiguratorInput!) {
  activateModularConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActivateModularConfiguratorGQL extends Apollo.Mutation<ActivateModularConfiguratorMutation, ActivateModularConfiguratorMutationVariables> {
    document = ActivateModularConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeactivateModularConfiguratorDocument = gql`
    mutation deactivateModularConfigurator($input: DeactivateModularConfiguratorInput!) {
  deactivateModularConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeactivateModularConfiguratorGQL extends Apollo.Mutation<DeactivateModularConfiguratorMutation, DeactivateModularConfiguratorMutationVariables> {
    document = DeactivateModularConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetCameraToModularConfiguratorDocument = gql`
    mutation setCameraToModularConfigurator($input: SetCameraToModularConfiguratorInput!) {
  setCameraToModularConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetCameraToModularConfiguratorGQL extends Apollo.Mutation<SetCameraToModularConfiguratorMutation, SetCameraToModularConfiguratorMutationVariables> {
    document = SetCameraToModularConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddCameraToModularConfiguratorComponentDocument = gql`
    mutation addCameraToModularConfiguratorComponent($input: AddCameraToModularConfiguratorComponentInput!) {
  addCameraToModularConfiguratorComponent(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCameraToModularConfiguratorComponentGQL extends Apollo.Mutation<AddCameraToModularConfiguratorComponentMutation, AddCameraToModularConfiguratorComponentMutationVariables> {
    document = AddCameraToModularConfiguratorComponentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCameraFromModularConfiguratorComponentDocument = gql`
    mutation deleteCameraFromModularConfiguratorComponent($input: DeleteCameraFromModularConfiguratorComponentInput!) {
  deleteCameraFromModularConfiguratorComponent(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCameraFromModularConfiguratorComponentGQL extends Apollo.Mutation<DeleteCameraFromModularConfiguratorComponentMutation, DeleteCameraFromModularConfiguratorComponentMutationVariables> {
    document = DeleteCameraFromModularConfiguratorComponentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeModularConfiguratorRootComponentTypeDocument = gql`
    mutation changeModularConfiguratorRootComponentType($input: ChangeModularConfiguratorRootComponentTypeInput!) {
  changeModularConfiguratorRootComponentType(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeModularConfiguratorRootComponentTypeGQL extends Apollo.Mutation<ChangeModularConfiguratorRootComponentTypeMutation, ChangeModularConfiguratorRootComponentTypeMutationVariables> {
    document = ChangeModularConfiguratorRootComponentTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeModularConfiguratorComponentTypePositionDocument = gql`
    mutation changeModularConfiguratorComponentTypePosition($input: ChangeModularConfiguratorComponentTypePositionInput!) {
  changeModularConfiguratorComponentTypePosition(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeModularConfiguratorComponentTypePositionGQL extends Apollo.Mutation<ChangeModularConfiguratorComponentTypePositionMutation, ChangeModularConfiguratorComponentTypePositionMutationVariables> {
    document = ChangeModularConfiguratorComponentTypePositionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddEnvironmentToModularConfiguratorDocument = gql`
    mutation addEnvironmentToModularConfigurator($input: AddEnvironmentToModularConfiguratorInput!) {
  addEnvironmentToModularConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddEnvironmentToModularConfiguratorGQL extends Apollo.Mutation<AddEnvironmentToModularConfiguratorMutation, AddEnvironmentToModularConfiguratorMutationVariables> {
    document = AddEnvironmentToModularConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveEnvironmentFromModularConfiguratorDocument = gql`
    mutation removeEnvironmentFromModularConfigurator($input: RemoveEnvironmentFromModularConfiguratorInput!) {
  removeEnvironmentFromModularConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveEnvironmentFromModularConfiguratorGQL extends Apollo.Mutation<RemoveEnvironmentFromModularConfiguratorMutation, RemoveEnvironmentFromModularConfiguratorMutationVariables> {
    document = RemoveEnvironmentFromModularConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddProductToModularConfiguratorDocument = gql`
    mutation addProductToModularConfigurator($input: AddProductToModularConfiguratorInput!) {
  addProductToModularConfigurator(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddProductToModularConfiguratorGQL extends Apollo.Mutation<AddProductToModularConfiguratorMutation, AddProductToModularConfiguratorMutationVariables> {
    document = AddProductToModularConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CloneModularConfiguratorDocument = gql`
    mutation cloneModularConfigurator($input: CloneModularConfiguratorInput!) {
  cloneModularConfigurator(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CloneModularConfiguratorGQL extends Apollo.Mutation<CloneModularConfiguratorMutation, CloneModularConfiguratorMutationVariables> {
    document = CloneModularConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteComponentFromModularConfiguratorDocument = gql`
    mutation deleteComponentFromModularConfigurator($input: DeleteComponentFromModularConfiguratorInput!) {
  deleteComponentFromModularConfigurator(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteComponentFromModularConfiguratorGQL extends Apollo.Mutation<DeleteComponentFromModularConfiguratorMutation, DeleteComponentFromModularConfiguratorMutationVariables> {
    document = DeleteComponentFromModularConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RenameModularConfiguratorComponentDocument = gql`
    mutation renameModularConfiguratorComponent($input: RenameModularConfiguratorComponentInput!) {
  renameModularConfiguratorComponent(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RenameModularConfiguratorComponentGQL extends Apollo.Mutation<RenameModularConfiguratorComponentMutation, RenameModularConfiguratorComponentMutationVariables> {
    document = RenameModularConfiguratorComponentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeModularConfiguratorEnvironmentPositionDocument = gql`
    mutation changeModularConfiguratorEnvironmentPosition($input: ChangeModularConfiguratorEnvironmentPositionInput!) {
  changeModularConfiguratorEnvironmentPosition(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeModularConfiguratorEnvironmentPositionGQL extends Apollo.Mutation<ChangeModularConfiguratorEnvironmentPositionMutation, ChangeModularConfiguratorEnvironmentPositionMutationVariables> {
    document = ChangeModularConfiguratorEnvironmentPositionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeModularConfiguratorComponentPositionDocument = gql`
    mutation changeModularConfiguratorComponentPosition($input: ChangeModularConfiguratorComponentPositionInput!) {
  changeModularConfiguratorComponentPosition(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeModularConfiguratorComponentPositionGQL extends Apollo.Mutation<ChangeModularConfiguratorComponentPositionMutation, ChangeModularConfiguratorComponentPositionMutationVariables> {
    document = ChangeModularConfiguratorComponentPositionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeModularConfiguratorEnvironmentLabelDocument = gql`
    mutation changeModularConfiguratorEnvironmentLabel($input: ChangeModularConfiguratorEnvironmentLabelInput!) {
  changeModularConfiguratorEnvironmentLabel(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeModularConfiguratorEnvironmentLabelGQL extends Apollo.Mutation<ChangeModularConfiguratorEnvironmentLabelMutation, ChangeModularConfiguratorEnvironmentLabelMutationVariables> {
    document = ChangeModularConfiguratorEnvironmentLabelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEnvironmentDocument = gql`
    mutation deleteEnvironment($input: DeleteEnvironmentInput!) {
  deleteEnvironment(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEnvironmentGQL extends Apollo.Mutation<DeleteEnvironmentMutation, DeleteEnvironmentMutationVariables> {
    document = DeleteEnvironmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeEnvironmentSlotLabelDocument = gql`
    mutation changeEnvironmentSlotLabel($input: ChangeEnvironmentSlotLabelInput!) {
  changeEnvironmentSlotLabel(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeEnvironmentSlotLabelGQL extends Apollo.Mutation<ChangeEnvironmentSlotLabelMutation, ChangeEnvironmentSlotLabelMutationVariables> {
    document = ChangeEnvironmentSlotLabelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeEnvironmentPreviewDocument = gql`
    mutation changeEnvironmentPreview($input: ChangeEnvironmentPreviewInput!) {
  changeEnvironmentPreview(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeEnvironmentPreviewGQL extends Apollo.Mutation<ChangeEnvironmentPreviewMutation, ChangeEnvironmentPreviewMutationVariables> {
    document = ChangeEnvironmentPreviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeEnvironmentTitleDocument = gql`
    mutation changeEnvironmentTitle($input: ChangeEnvironmentTitleInput!) {
  changeEnvironmentTitle(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeEnvironmentTitleGQL extends Apollo.Mutation<ChangeEnvironmentTitleMutation, ChangeEnvironmentTitleMutationVariables> {
    document = ChangeEnvironmentTitleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnableEnvironmentUdsDocument = gql`
    mutation enableEnvironmentUds($input: EnableEnvironmentUdsInput!) {
  enableEnvironmentUds(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnableEnvironmentUdsGQL extends Apollo.Mutation<EnableEnvironmentUdsMutation, EnableEnvironmentUdsMutationVariables> {
    document = EnableEnvironmentUdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisableEnvironmentUdsDocument = gql`
    mutation disableEnvironmentUds($input: DisableEnvironmentUdsInput!) {
  disableEnvironmentUds(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisableEnvironmentUdsGQL extends Apollo.Mutation<DisableEnvironmentUdsMutation, DisableEnvironmentUdsMutationVariables> {
    document = DisableEnvironmentUdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeEnvironmentUdsHourDocument = gql`
    mutation changeEnvironmentUdsHour($input: ChangeEnvironmentUdsHourInput!) {
  changeEnvironmentUdsHour(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeEnvironmentUdsHourGQL extends Apollo.Mutation<ChangeEnvironmentUdsHourMutation, ChangeEnvironmentUdsHourMutationVariables> {
    document = ChangeEnvironmentUdsHourDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeEnvironmentSunNorthYawDocument = gql`
    mutation changeEnvironmentSunNorthYaw($input: ChangeEnvironmentSunNorthYawInput!) {
  changeEnvironmentSunNorthYaw(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeEnvironmentSunNorthYawGQL extends Apollo.Mutation<ChangeEnvironmentSunNorthYawMutation, ChangeEnvironmentSunNorthYawMutationVariables> {
    document = ChangeEnvironmentSunNorthYawDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CloneEnvironmentToClientDocument = gql`
    mutation cloneEnvironmentToClient($input: CloneEnvironmentToClientInput!) {
  cloneEnvironmentToClient(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CloneEnvironmentToClientGQL extends Apollo.Mutation<CloneEnvironmentToClientMutation, CloneEnvironmentToClientMutationVariables> {
    document = CloneEnvironmentToClientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeEnvironmentPreviewFromRenderDocument = gql`
    mutation changeEnvironmentPreviewFromRender($input: ChangeEnvironmentPreviewFromRenderInput!) {
  changeEnvironmentPreviewFromRender(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeEnvironmentPreviewFromRenderGQL extends Apollo.Mutation<ChangeEnvironmentPreviewFromRenderMutation, ChangeEnvironmentPreviewFromRenderMutationVariables> {
    document = ChangeEnvironmentPreviewFromRenderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMaterialDocument = gql`
    mutation deleteMaterial($input: DeleteMaterialInput!) {
  deleteMaterial(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMaterialGQL extends Apollo.Mutation<DeleteMaterialMutation, DeleteMaterialMutationVariables> {
    document = DeleteMaterialDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnableMaterialForEnvironmentSlotDocument = gql`
    mutation enableMaterialForEnvironmentSlot($input: EnableMaterialForEnvironmentSlotInput!) {
  enableMaterialForEnvironmentSlot(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnableMaterialForEnvironmentSlotGQL extends Apollo.Mutation<EnableMaterialForEnvironmentSlotMutation, EnableMaterialForEnvironmentSlotMutationVariables> {
    document = EnableMaterialForEnvironmentSlotDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisableMaterialForEnvironmentSlotDocument = gql`
    mutation disableMaterialForEnvironmentSlot($input: DisableMaterialForEnvironmentSlotInput!) {
  disableMaterialForEnvironmentSlot(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisableMaterialForEnvironmentSlotGQL extends Apollo.Mutation<DisableMaterialForEnvironmentSlotMutation, DisableMaterialForEnvironmentSlotMutationVariables> {
    document = DisableMaterialForEnvironmentSlotDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnableMaterialForProductSlotDocument = gql`
    mutation enableMaterialForProductSlot($input: EnableMaterialForProductSlotInput!) {
  enableMaterialForProductSlot(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnableMaterialForProductSlotGQL extends Apollo.Mutation<EnableMaterialForProductSlotMutation, EnableMaterialForProductSlotMutationVariables> {
    document = EnableMaterialForProductSlotDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisableMaterialForProductSlotDocument = gql`
    mutation disableMaterialForProductSlot($input: DisableMaterialForProductSlotInput!) {
  disableMaterialForProductSlot(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisableMaterialForProductSlotGQL extends Apollo.Mutation<DisableMaterialForProductSlotMutation, DisableMaterialForProductSlotMutationVariables> {
    document = DisableMaterialForProductSlotDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeMaterialPreviewDocument = gql`
    mutation changeMaterialPreview($input: ChangeMaterialPreviewInput!) {
  changeMaterialPreview(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeMaterialPreviewGQL extends Apollo.Mutation<ChangeMaterialPreviewMutation, ChangeMaterialPreviewMutationVariables> {
    document = ChangeMaterialPreviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeMaterialTitleDocument = gql`
    mutation changeMaterialTitle($input: ChangeMaterialTitleInput!) {
  changeMaterialTitle(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeMaterialTitleGQL extends Apollo.Mutation<ChangeMaterialTitleMutation, ChangeMaterialTitleMutationVariables> {
    document = ChangeMaterialTitleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeMaterialExternalIdDocument = gql`
    mutation changeMaterialExternalId($input: ChangeMaterialExternalIdInput!) {
  changeMaterialExternalId(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeMaterialExternalIdGQL extends Apollo.Mutation<ChangeMaterialExternalIdMutation, ChangeMaterialExternalIdMutationVariables> {
    document = ChangeMaterialExternalIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnableMaterialsFromAnotherEnvironmentSlotDocument = gql`
    mutation enableMaterialsFromAnotherEnvironmentSlot($input: EnableMaterialsFromAnotherEnvironmentSlotInput!) {
  enableMaterialsFromAnotherEnvironmentSlot(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnableMaterialsFromAnotherEnvironmentSlotGQL extends Apollo.Mutation<EnableMaterialsFromAnotherEnvironmentSlotMutation, EnableMaterialsFromAnotherEnvironmentSlotMutationVariables> {
    document = EnableMaterialsFromAnotherEnvironmentSlotDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnableMaterialsFromAnotherProductSlotDocument = gql`
    mutation enableMaterialsFromAnotherProductSlot($input: EnableMaterialsFromAnotherProductSlotInput!) {
  enableMaterialsFromAnotherProductSlot(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnableMaterialsFromAnotherProductSlotGQL extends Apollo.Mutation<EnableMaterialsFromAnotherProductSlotMutation, EnableMaterialsFromAnotherProductSlotMutationVariables> {
    document = EnableMaterialsFromAnotherProductSlotDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisableAllMaterialsForEnvironmentSlotDocument = gql`
    mutation disableAllMaterialsForEnvironmentSlot($input: DisableAllMaterialsForEnvironmentSlotInput!) {
  disableAllMaterialsForEnvironmentSlot(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisableAllMaterialsForEnvironmentSlotGQL extends Apollo.Mutation<DisableAllMaterialsForEnvironmentSlotMutation, DisableAllMaterialsForEnvironmentSlotMutationVariables> {
    document = DisableAllMaterialsForEnvironmentSlotDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisableAllMaterialsForProductSlotDocument = gql`
    mutation disableAllMaterialsForProductSlot($input: DisableAllMaterialsForProductSlotInput!) {
  disableAllMaterialsForProductSlot(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisableAllMaterialsForProductSlotGQL extends Apollo.Mutation<DisableAllMaterialsForProductSlotMutation, DisableAllMaterialsForProductSlotMutationVariables> {
    document = DisableAllMaterialsForProductSlotDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveProductMaterialDocument = gql`
    mutation moveProductMaterial($input: MoveProductMaterialInput!) {
  moveProductMaterial(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveProductMaterialGQL extends Apollo.Mutation<MoveProductMaterialMutation, MoveProductMaterialMutationVariables> {
    document = MoveProductMaterialDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveEnvironmentMaterialDocument = gql`
    mutation moveEnvironmentMaterial($input: MoveEnvironmentMaterialInput!) {
  moveEnvironmentMaterial(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveEnvironmentMaterialGQL extends Apollo.Mutation<MoveEnvironmentMaterialMutation, MoveEnvironmentMaterialMutationVariables> {
    document = MoveEnvironmentMaterialDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CloneMaterialToClientDocument = gql`
    mutation cloneMaterialToClient($input: CloneMaterialToClientInput!) {
  cloneMaterialToClient(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CloneMaterialToClientGQL extends Apollo.Mutation<CloneMaterialToClientMutation, CloneMaterialToClientMutationVariables> {
    document = CloneMaterialToClientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportProductsMetaDataDocument = gql`
    mutation importProductsMetaData($input: ImportProductsMetaDataInput!) {
  importProductsMetaData(input: $input) {
    completed
    warnings
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportProductsMetaDataGQL extends Apollo.Mutation<ImportProductsMetaDataMutation, ImportProductsMetaDataMutationVariables> {
    document = ImportProductsMetaDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMetaPropertyDocument = gql`
    mutation createMetaProperty($input: CreateMetaPropertyInput!) {
  createMetaProperty(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMetaPropertyGQL extends Apollo.Mutation<CreateMetaPropertyMutation, CreateMetaPropertyMutationVariables> {
    document = CreateMetaPropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMetaPropertyDocument = gql`
    mutation deleteMetaProperty($input: DeleteMetaPropertyInput!) {
  deleteMetaProperty(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMetaPropertyGQL extends Apollo.Mutation<DeleteMetaPropertyMutation, DeleteMetaPropertyMutationVariables> {
    document = DeleteMetaPropertyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeMetaPropertyTypeDocument = gql`
    mutation changeMetaPropertyType($input: ChangeMetaPropertyTypeInput!) {
  changeMetaPropertyType(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeMetaPropertyTypeGQL extends Apollo.Mutation<ChangeMetaPropertyTypeMutation, ChangeMetaPropertyTypeMutationVariables> {
    document = ChangeMetaPropertyTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePresetDocument = gql`
    mutation createPreset($input: CreatePresetInput!) {
  createPreset(input: $input) {
    id
    title
    config
    createdAt
    previewPath
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePresetGQL extends Apollo.Mutation<CreatePresetMutation, CreatePresetMutationVariables> {
    document = CreatePresetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePresetDocument = gql`
    mutation deletePreset($input: DeletePresetInput!) {
  deletePreset(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePresetGQL extends Apollo.Mutation<DeletePresetMutation, DeletePresetMutationVariables> {
    document = DeletePresetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeProductExternalIdDocument = gql`
    mutation changeProductExternalId($input: ChangeProductExternalIdInput!) {
  changeProductExternalId(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeProductExternalIdGQL extends Apollo.Mutation<ChangeProductExternalIdMutation, ChangeProductExternalIdMutationVariables> {
    document = ChangeProductExternalIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeProductPreviewDocument = gql`
    mutation changeProductPreview($input: ChangeProductPreviewInput!) {
  changeProductPreview(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeProductPreviewGQL extends Apollo.Mutation<ChangeProductPreviewMutation, ChangeProductPreviewMutationVariables> {
    document = ChangeProductPreviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeProductTitleDocument = gql`
    mutation changeProductTitle($input: ChangeProductTitleInput!) {
  changeProductTitle(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeProductTitleGQL extends Apollo.Mutation<ChangeProductTitleMutation, ChangeProductTitleMutationVariables> {
    document = ChangeProductTitleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteProductDocument = gql`
    mutation deleteProduct($input: DeleteProductInput!) {
  deleteProduct(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteProductGQL extends Apollo.Mutation<DeleteProductMutation, DeleteProductMutationVariables> {
    document = DeleteProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeProductSlotLabelDocument = gql`
    mutation changeProductSlotLabel($input: ChangeProductSlotLabelInput!) {
  changeProductSlotLabel(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeProductSlotLabelGQL extends Apollo.Mutation<ChangeProductSlotLabelMutation, ChangeProductSlotLabelMutationVariables> {
    document = ChangeProductSlotLabelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetProductLowBandwidthTimecodesDocument = gql`
    mutation setProductLowBandwidthTimecodes($input: SetProductLowBandwidthTimecodesInput!) {
  setProductLowBandwidthTimecodes(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetProductLowBandwidthTimecodesGQL extends Apollo.Mutation<SetProductLowBandwidthTimecodesMutation, SetProductLowBandwidthTimecodesMutationVariables> {
    document = SetProductLowBandwidthTimecodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CloneProductToClientDocument = gql`
    mutation cloneProductToClient($input: CloneProductToClientInput!) {
  cloneProductToClient(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CloneProductToClientGQL extends Apollo.Mutation<CloneProductToClientMutation, CloneProductToClientMutationVariables> {
    document = CloneProductToClientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeProductPreviewFromRenderDocument = gql`
    mutation changeProductPreviewFromRender($input: ChangeProductPreviewFromRenderInput!) {
  changeProductPreviewFromRender(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeProductPreviewFromRenderGQL extends Apollo.Mutation<ChangeProductPreviewFromRenderMutation, ChangeProductPreviewFromRenderMutationVariables> {
    document = ChangeProductPreviewFromRenderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRenderRequestDocument = gql`
    mutation createRenderRequest($input: CreateRenderRequestInput!) {
  createRenderRequest(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRenderRequestGQL extends Apollo.Mutation<CreateRenderRequestMutation, CreateRenderRequestMutationVariables> {
    document = CreateRenderRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRenderDocument = gql`
    mutation deleteRender($input: DeleteRenderInput!) {
  deleteRender(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRenderGQL extends Apollo.Mutation<DeleteRenderMutation, DeleteRenderMutationVariables> {
    document = DeleteRenderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSpinnerRequestDocument = gql`
    mutation createSpinnerRequest($input: CreateSpinnerRequestInput!) {
  createSpinnerRequest(input: $input) {
    id
    spinnerId
    status
    uploadUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSpinnerRequestGQL extends Apollo.Mutation<CreateSpinnerRequestMutation, CreateSpinnerRequestMutationVariables> {
    document = CreateSpinnerRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSpinnerDocument = gql`
    mutation deleteSpinner($input: DeleteSpinnerInput!) {
  deleteSpinner(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSpinnerGQL extends Apollo.Mutation<DeleteSpinnerMutation, DeleteSpinnerMutationVariables> {
    document = DeleteSpinnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAssetCreationRequestDocument = gql`
    mutation createAssetCreationRequest($input: CreateAssetCreationRequestInput!) {
  createAssetCreationRequest(input: $input) {
    completed
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAssetCreationRequestGQL extends Apollo.Mutation<CreateAssetCreationRequestMutation, CreateAssetCreationRequestMutationVariables> {
    document = CreateAssetCreationRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClientDocument = gql`
    query client($input: GetClientInput!) {
  client(input: $input) {
    hasPublicAssets
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClientGQL extends Apollo.Query<ClientQuery, ClientQueryVariables> {
    document = ClientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClientListDocument = gql`
    query clientList($input: GetClientListInput!) {
  clientList(input: $input) {
    clients {
      id
      name
      unrealVersion
      hasPublicAssets
    }
    limit
    offset
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClientListGQL extends Apollo.Query<ClientListQuery, ClientListQueryVariables> {
    document = ClientListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BasicConfiguratorListDocument = gql`
    query basicConfiguratorList($input: GetBasicConfiguratorListInput!) {
  basicConfiguratorList(input: $input) {
    basicConfigurators {
      id
      name
      isActive
      ctaEnabled
      environments {
        environmentId
        label
        environment {
          title
          thumbnailList {
            ...Thumbnail
          }
        }
      }
      products {
        productId
        label
        product {
          externalId
          thumbnailList {
            ...Thumbnail
          }
        }
      }
    }
    limit
    total
    offset
  }
}
    ${ThumbnailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BasicConfiguratorListGQL extends Apollo.Query<BasicConfiguratorListQuery, BasicConfiguratorListQueryVariables> {
    document = BasicConfiguratorListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BasicConfiguratorEnvironmentsDocument = gql`
    query basicConfiguratorEnvironments($input: GetBasicConfiguratorInput!) {
  basicConfigurator(input: $input) {
    id
    environments {
      environmentId
      position
      label
      environment {
        title
        thumbnailList {
          ...Thumbnail
        }
      }
    }
  }
}
    ${ThumbnailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BasicConfiguratorEnvironmentsGQL extends Apollo.Query<BasicConfiguratorEnvironmentsQuery, BasicConfiguratorEnvironmentsQueryVariables> {
    document = BasicConfiguratorEnvironmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BasicConfiguratorProductsDocument = gql`
    query basicConfiguratorProducts($input: GetBasicConfiguratorInput!) {
  basicConfigurator(input: $input) {
    id
    products {
      productId
      position
      label
      camera {
        ...Camera
      }
      product {
        externalId
        title
        thumbnailList {
          ...Thumbnail
        }
      }
    }
  }
}
    ${CameraFragmentDoc}
${ThumbnailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BasicConfiguratorProductsGQL extends Apollo.Query<BasicConfiguratorProductsQuery, BasicConfiguratorProductsQueryVariables> {
    document = BasicConfiguratorProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ModularConfiguratorListDocument = gql`
    query modularConfiguratorList($input: GetModularConfiguratorListInput!) {
  modularConfiguratorList(input: $input) {
    modularConfigurators {
      id
      name
      isActive
      ctaEnabled
      environments {
        environmentId
        environment {
          title
          thumbnailList {
            ...Thumbnail
          }
        }
      }
      components {
        id
        componentType {
          id
          name
          position
          isRoot
          isRequired
        }
        name
        position
        product {
          id
          title
          externalId
          thumbnailList {
            ...Thumbnail
          }
        }
      }
    }
    limit
    total
    offset
  }
}
    ${ThumbnailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ModularConfiguratorListGQL extends Apollo.Query<ModularConfiguratorListQuery, ModularConfiguratorListQueryVariables> {
    document = ModularConfiguratorListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ModularConfiguratorEnvironmentsDocument = gql`
    query modularConfiguratorEnvironments($input: GetModularConfiguratorInput!) {
  modularConfigurator(input: $input) {
    id
    environments {
      environmentId
      position
      label
      environment {
        title
        thumbnailList {
          ...Thumbnail
        }
      }
    }
  }
}
    ${ThumbnailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ModularConfiguratorEnvironmentsGQL extends Apollo.Query<ModularConfiguratorEnvironmentsQuery, ModularConfiguratorEnvironmentsQueryVariables> {
    document = ModularConfiguratorEnvironmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ModularConfiguratorComponentsDocument = gql`
    query modularConfiguratorComponents($input: GetModularConfiguratorInput!) {
  modularConfigurator(input: $input) {
    id
    componentTypes {
      id
      name
      position
      isRoot
      isRequired
    }
    components {
      id
      componentType {
        name
        position
        isRoot
        isRequired
        id
      }
      name
      position
      camera {
        ...Camera
      }
      product {
        clientId
        title
        externalId
        thumbnailList {
          ...Thumbnail
        }
        slots {
          ...SlotData
        }
        model {
          ...Model
        }
        id
        showcase {
          ...Showcase
        }
      }
    }
  }
}
    ${CameraFragmentDoc}
${ThumbnailFragmentDoc}
${SlotDataFragmentDoc}
${ModelFragmentDoc}
${ShowcaseFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ModularConfiguratorComponentsGQL extends Apollo.Query<ModularConfiguratorComponentsQuery, ModularConfiguratorComponentsQueryVariables> {
    document = ModularConfiguratorComponentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BasicConfiguratorDocument = gql`
    query basicConfigurator($input: GetBasicConfiguratorInput!) {
  basicConfigurator(input: $input) {
    id
    isActive
    ctaEnabled
    productCollectionLabel
    name
    camera {
      ...Camera
    }
    client {
      ...Client
    }
    products {
      productId
      position
      label
      camera {
        ...Camera
      }
      product {
        externalId
        metaProperties {
          id
          value
          type
          name
        }
        title
        thumbnailList {
          ...Thumbnail
        }
        slots {
          ...SlotData
        }
        model {
          ...Model
        }
        id
        showcase {
          ...Showcase
        }
      }
    }
    environments {
      environmentId
      position
      label
      environment {
        id
        title
        ...SunData
        thumbnailList {
          ...Thumbnail
        }
        slots {
          ...SlotData
        }
        model {
          ...Model
        }
      }
    }
  }
}
    ${CameraFragmentDoc}
${ClientFragmentDoc}
${ThumbnailFragmentDoc}
${SlotDataFragmentDoc}
${ModelFragmentDoc}
${ShowcaseFragmentDoc}
${SunDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BasicConfiguratorGQL extends Apollo.Query<BasicConfiguratorQuery, BasicConfiguratorQueryVariables> {
    document = BasicConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ModularConfiguratorDocument = gql`
    query modularConfigurator($input: GetModularConfiguratorInput!) {
  modularConfigurator(input: $input) {
    id
    isActive
    ctaEnabled
    name
    camera {
      ...Camera
    }
    client {
      ...Client
    }
    componentTypes {
      name
      position
      isRoot
      isRequired
      id
    }
    connectors {
      id
      componentTypeId1
      componentTypeId2
    }
    components {
      id
      componentType {
        name
        position
        isRoot
        isRequired
        id
      }
      name
      position
      virtualSocketToConnectorsMap {
        virtualSocketId
        connectorId
      }
      position
      camera {
        ...Camera
      }
      product {
        externalId
        title
        thumbnailList {
          ...Thumbnail
        }
        metaProperties {
          id
          value
          type
          name
        }
        virtualSockets {
          id
          name
          originalSockets
        }
        slots {
          ...SlotData
        }
        model {
          ...Model
        }
        id
        showcase {
          ...Showcase
        }
      }
    }
    environments {
      environmentId
      position
      label
      environment {
        id
        title
        ...SunData
        thumbnailList {
          ...Thumbnail
        }
        slots {
          ...SlotData
        }
        model {
          ...Model
        }
      }
    }
  }
}
    ${CameraFragmentDoc}
${ClientFragmentDoc}
${ThumbnailFragmentDoc}
${SlotDataFragmentDoc}
${ModelFragmentDoc}
${ShowcaseFragmentDoc}
${SunDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ModularConfiguratorGQL extends Apollo.Query<ModularConfiguratorQuery, ModularConfiguratorQueryVariables> {
    document = ModularConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnvironmentDocument = gql`
    query environment($input: GetEnvironmentInput!) {
  environment(input: $input) {
    __typename
    id
    title
    clientId
    model {
      ...Model
    }
    ...SunData
    thumbnailList {
      ...Thumbnail
    }
    slots {
      ...SlotData
    }
  }
}
    ${ModelFragmentDoc}
${SunDataFragmentDoc}
${ThumbnailFragmentDoc}
${SlotDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EnvironmentGQL extends Apollo.Query<EnvironmentQuery, EnvironmentQueryVariables> {
    document = EnvironmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnvironmentWithClientAndUVersionDocument = gql`
    query environmentWithClientAndUVersion($input: GetEnvironmentInput!) {
  environment(input: $input) {
    id
    clientId
    ...SunData
    model {
      ...Model
    }
  }
}
    ${SunDataFragmentDoc}
${ModelFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EnvironmentWithClientAndUVersionGQL extends Apollo.Query<EnvironmentWithClientAndUVersionQuery, EnvironmentWithClientAndUVersionQueryVariables> {
    document = EnvironmentWithClientAndUVersionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnvironmentListDocument = gql`
    query environmentList($input: GetEnvironmentListInput!) {
  environmentList(input: $input) {
    environments {
      id
      legacyAssetId
      title
      ...SunData
      thumbnailList {
        ...Thumbnail
      }
      model {
        ...Model
      }
      slots {
        ...SlotData
      }
    }
    limit
    total
    offset
  }
}
    ${SunDataFragmentDoc}
${ThumbnailFragmentDoc}
${ModelFragmentDoc}
${SlotDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EnvironmentListGQL extends Apollo.Query<EnvironmentListQuery, EnvironmentListQueryVariables> {
    document = EnvironmentListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnvironmentRendersDocument = gql`
    query environmentRenders($input: GetEnvironmentInput!, $offset: Int, $limit: Int, $countTotal: Boolean) {
  environment(input: $input) {
    id
    renders(offset: $offset, limit: $limit, countTotal: $countTotal) {
      renders {
        id
        filePath
        renderRequest {
          id
          previewPath
          serialNumber
          createdAt
          status
        }
      }
      limit
      total
      offset
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnvironmentRendersGQL extends Apollo.Query<EnvironmentRendersQuery, EnvironmentRendersQueryVariables> {
    document = EnvironmentRendersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnvironmentRendersDownloadDocument = gql`
    query environmentRendersDownload($input: GetEnvironmentInput!, $offset: Int, $limit: Int, $countTotal: Boolean) {
  environment(input: $input) {
    id
    title
    renders(offset: $offset, limit: $limit, countTotal: $countTotal) {
      renders {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnvironmentRendersDownloadGQL extends Apollo.Query<EnvironmentRendersDownloadQuery, EnvironmentRendersDownloadQueryVariables> {
    document = EnvironmentRendersDownloadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnvironmentCameraPresetsDocument = gql`
    query environmentCameraPresets($input: GetEnvironmentInput!, $offset: Int, $limit: Int, $countTotal: Boolean) {
  environment(input: $input) {
    id
    title
    cameraPresets(offset: $offset, limit: $limit, countTotal: $countTotal) {
      cameraPresets {
        id
        config
        previewPath
        isLocked
        title
      }
      limit
      total
      offset
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EnvironmentCameraPresetsGQL extends Apollo.Query<EnvironmentCameraPresetsQuery, EnvironmentCameraPresetsQueryVariables> {
    document = EnvironmentCameraPresetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnvironmentMaterialsDocument = gql`
    query environmentMaterials($input: GetEnvironmentInput!) {
  environment(input: $input) {
    id
    slots {
      ...SlotData
    }
  }
}
    ${SlotDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EnvironmentMaterialsGQL extends Apollo.Query<EnvironmentMaterialsQuery, EnvironmentMaterialsQueryVariables> {
    document = EnvironmentMaterialsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialDocument = gql`
    query material($input: GetMaterialInput!) {
  material(input: $input) {
    id
    externalId
    title
    thumbnailList {
      ...Thumbnail
    }
  }
}
    ${ThumbnailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialGQL extends Apollo.Query<MaterialQuery, MaterialQueryVariables> {
    document = MaterialDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialListDocument = gql`
    query materialList($input: GetMaterialListInput!) {
  materialList(input: $input) {
    materials {
      id
      externalId
      title
      thumbnailList {
        ...Thumbnail
      }
    }
    limit
    total
    offset
  }
}
    ${ThumbnailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialListGQL extends Apollo.Query<MaterialListQuery, MaterialListQueryVariables> {
    document = MaterialListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MetaPropertyListDocument = gql`
    query metaPropertyList($input: GetMetaPropertyListInput!) {
  metaPropertyList(input: $input) {
    metaProperties {
      id
      name
      type
      expression
    }
    limit
    total
    offset
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MetaPropertyListGQL extends Apollo.Query<MetaPropertyListQuery, MetaPropertyListQueryVariables> {
    document = MetaPropertyListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PresetListDocument = gql`
    query presetList($input: GetPresetListInput!) {
  presetList(input: $input) {
    presets {
      id
      title
      config
      previewPath
      createdAt
      environment {
        id
        title
        clientId
        model {
          ...Model
        }
        ...SunData
        thumbnailList {
          ...Thumbnail
        }
        slots {
          ...SlotData
        }
      }
    }
    limit
    total
    offset
  }
}
    ${ModelFragmentDoc}
${SunDataFragmentDoc}
${ThumbnailFragmentDoc}
${SlotDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PresetListGQL extends Apollo.Query<PresetListQuery, PresetListQueryVariables> {
    document = PresetListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PresetCategoriesDocument = gql`
    query presetCategories($input: GetEnvironmentListInput!) {
  environmentList(input: $input) {
    environments {
      id
      title
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PresetCategoriesGQL extends Apollo.Query<PresetCategoriesQuery, PresetCategoriesQueryVariables> {
    document = PresetCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductDocument = gql`
    query product($input: GetProductInput!) {
  product(input: $input) {
    __typename
    id
    externalId
    title
    showcase {
      ...Showcase
    }
    thumbnailList {
      ...Thumbnail
    }
    slots {
      ...SlotData
    }
    model {
      ...Model
    }
  }
}
    ${ShowcaseFragmentDoc}
${ThumbnailFragmentDoc}
${SlotDataFragmentDoc}
${ModelFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductGQL extends Apollo.Query<ProductQuery, ProductQueryVariables> {
    document = ProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductWithClientAndUVersionDocument = gql`
    query productWithClientAndUVersion($input: GetProductInput!) {
  product(input: $input) {
    __typename
    id
    clientId
    model {
      ...Model
    }
    slots {
      ...SlotData
    }
  }
}
    ${ModelFragmentDoc}
${SlotDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductWithClientAndUVersionGQL extends Apollo.Query<ProductWithClientAndUVersionQuery, ProductWithClientAndUVersionQueryVariables> {
    document = ProductWithClientAndUVersionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductListDocument = gql`
    query productList($input: GetProductListInput!) {
  productList(input: $input) {
    products {
      legacyAssetId
      id
      clientId
      title
      externalId
      virtualSockets {
        id
        name
      }
      productType {
        id
        name
      }
      showcase {
        ...Showcase
      }
      thumbnailList {
        ...Thumbnail
      }
      model {
        ...Model
      }
      slots {
        ...SlotData
      }
    }
    limit
    total
    offset
  }
}
    ${ShowcaseFragmentDoc}
${ThumbnailFragmentDoc}
${ModelFragmentDoc}
${SlotDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductListGQL extends Apollo.Query<ProductListQuery, ProductListQueryVariables> {
    document = ProductListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductRendersDocument = gql`
    query productRenders($input: GetProductInput!, $offset: Int, $limit: Int, $countTotal: Boolean) {
  product(input: $input) {
    id
    renders(offset: $offset, limit: $limit, countTotal: $countTotal) {
      renders {
        id
        filePath
        renderRequest {
          id
          previewPath
          serialNumber
          createdAt
          status
        }
      }
      limit
      total
      offset
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductRendersGQL extends Apollo.Query<ProductRendersQuery, ProductRendersQueryVariables> {
    document = ProductRendersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductSpinnersDocument = gql`
    query productSpinners($input: GetProductInput!, $offset: Int, $limit: Int, $countTotal: Boolean) {
  product(input: $input) {
    id
    spinners(offset: $offset, limit: $limit, countTotal: $countTotal) {
      spinners {
        ...Spinner
      }
      limit
      total
      offset
    }
  }
}
    ${SpinnerFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductSpinnersGQL extends Apollo.Query<ProductSpinnersQuery, ProductSpinnersQueryVariables> {
    document = ProductSpinnersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductRendersSpinnersDownloadDocument = gql`
    query productRendersSpinnersDownload($input: GetProductInput!, $offset: Int, $limit: Int, $countTotal: Boolean) {
  product(input: $input) {
    id
    title
    renders(offset: $offset, limit: $limit, countTotal: $countTotal) {
      renders {
        id
      }
    }
    spinners(offset: $offset, limit: $limit, countTotal: $countTotal) {
      spinners {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductRendersSpinnersDownloadGQL extends Apollo.Query<ProductRendersSpinnersDownloadQuery, ProductRendersSpinnersDownloadQueryVariables> {
    document = ProductRendersSpinnersDownloadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductCameraPresetsDocument = gql`
    query productCameraPresets($input: GetProductInput!, $offset: Int, $limit: Int, $countTotal: Boolean) {
  product(input: $input) {
    id
    title
    cameraPresets(offset: $offset, limit: $limit, countTotal: $countTotal) {
      cameraPresets {
        id
        config
        previewPath
        isLocked
        title
      }
      limit
      total
      offset
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductCameraPresetsGQL extends Apollo.Query<ProductCameraPresetsQuery, ProductCameraPresetsQueryVariables> {
    document = ProductCameraPresetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductMaterialsDocument = gql`
    query productMaterials($input: GetProductInput!) {
  product(input: $input) {
    id
    slots {
      ...SlotData
    }
  }
}
    ${SlotDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductMaterialsGQL extends Apollo.Query<ProductMaterialsQuery, ProductMaterialsQueryVariables> {
    document = ProductMaterialsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RenderListDocument = gql`
    query renderList($input: GetRenderListInput!) {
  renderList(input: $input) {
    renders {
      id
      filePath
      renderRequest {
        id
        previewPath
        serialNumber
        createdAt
        status
        email
        author {
          firstName
          lastName
        }
        fileType
        height
        width
        fov
      }
    }
    limit
    total
    offset
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RenderListGQL extends Apollo.Query<RenderListQuery, RenderListQueryVariables> {
    document = RenderListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RenderDocument = gql`
    query render($input: GetRenderInput!) {
  render(input: $input) {
    id
    filePath
    fullSizePreviewPath
    fileSize
    renderRequest {
      id
      previewPath
      serialNumber
      configuration
      email
      height
      width
      fov
      author {
        firstName
        lastName
      }
      fileType
      status
      createdAt
      products {
        id
        legacyAssetId
        externalId
        title
        showcase {
          ...Showcase
        }
        thumbnailList {
          ...Thumbnail
        }
        slots {
          ...SlotData
        }
        model {
          ...Model
        }
      }
      environment {
        id
        legacyAssetId
        title
        clientId
        model {
          ...Model
        }
        ...SunData
        thumbnailList {
          ...Thumbnail
        }
        slots {
          ...SlotData
        }
      }
    }
  }
}
    ${ShowcaseFragmentDoc}
${ThumbnailFragmentDoc}
${SlotDataFragmentDoc}
${ModelFragmentDoc}
${SunDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RenderGQL extends Apollo.Query<RenderQuery, RenderQueryVariables> {
    document = RenderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RenderRequestParamsDocument = gql`
    query renderRequestParams($input: GetRenderRequestInput!) {
  renderRequest(input: $input) {
    id
    renderResultUrl
    renderId
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RenderRequestParamsGQL extends Apollo.Query<RenderRequestParamsQuery, RenderRequestParamsQueryVariables> {
    document = RenderRequestParamsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SpinnerDocument = gql`
    query spinner($input: GetSpinnerInput!) {
  spinner(input: $input) {
    ...Spinner
  }
}
    ${SpinnerFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SpinnerGQL extends Apollo.Query<SpinnerQuery, SpinnerQueryVariables> {
    document = SpinnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssetCreationRequestListDocument = gql`
    query assetCreationRequestList($input: GetAssetCreationRequestListInput!) {
  assetCreationRequestList(input: $input) {
    assetCreationRequests {
      id
      status
      assetType
      assetId
      errors
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssetCreationRequestListGQL extends Apollo.Query<AssetCreationRequestListQuery, AssetCreationRequestListQueryVariables> {
    document = AssetCreationRequestListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }